import React, { Component } from 'react';
import Title from '../Assets/breadcrumbs-title.png';
import SmallCrumb1 from '../Assets/Crumbs/small-crumb1.png';
import SmallCrumb2 from '../Assets/Crumbs/small-crumb2.png';
import SmallCrumb3 from '../Assets/Crumbs/small-crumb3.png';
import MediumCrumb1 from '../Assets/Crumbs/medium-crumb1.png';
import MediumCrumb2 from '../Assets/Crumbs/medium-crumb2.png';
import LargeCrumb1 from '../Assets/Crumbs/large-crumb1.png';
import LargeCrumb2 from '../Assets/Crumbs/large-crumb2.png';
import LargeCrumb1Play from '../Assets/Crumbs/large-crumb1-play.png';
import LargeCrumb2Play from '../Assets/Crumbs/large-crumb2-play.png';
import LargeCrumb1Pause from '../Assets/Crumbs/large-crumb1-pause.png';
import LargeCrumb2Pause from '../Assets/Crumbs/large-crumb2-pause.png';
import SmallTrio from '../Assets/Clumps/small-trio.png';
import SmallClump from '../Assets/Clumps/small-clump.png';
import LargeClump from '../Assets/Clumps/large-clump.png';
import AssortedClump from '../Assets/Clumps/assorted-clump.png';
import AssortedClumpPlay from '../Assets/Clumps/assorted-clump-play.png';
import AssortedClumpPause from '../Assets/Clumps/assorted-clump-pause.png';
import CardBackground from '../Assets/card-background.jpeg';
import Modal from 'react-bootstrap/Modal';
// import axios from 'axios';
import { Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faVolumeUp, faVolumeMute, faDeaf, faAssistiveListeningSystems } from '@fortawesome/free-solid-svg-icons';
import BlueBird from '../Assets/Birds/blue-bird.png';
import PinkBird from '../Assets/Birds/pink-bird.png';
import GreenBird2 from '../Assets/Birds/green-bird2.png';
import SmallRock from '../Assets/Rocks/small-rock.png';
import LargeRock from '../Assets/Rocks/large-rock.png';
import Plant1 from '../Assets/Plants/plant1.png';
import Plant2 from '../Assets/Plants/plant2.png';
import '../Styles/Trail.css';

// let api_url = "http://0.0.0.0:3001/"
// let api_url = "https://api.breadcrumbsproject.com/"

let questions = [
  "A memory of the best smell from the kitchen", 
  "A memory of the person who fed you the most growing up", 
  "A memory of a food-related tradition", 
  "A memory of a meal you wish you could eat again", 
  "A memory of dinner table rules",
  "A memory of the person who taught you to cook",
  "A memory of something hard to swallow",
  "A memory that belongs in this project" ]

let text_stories = [
  { title: "", 
    memory: "", 
    story: "Welcome to the breadcrumb trail. I\u2019m Kristen but after this audio clip you\u2019re not going to hear from me again. as you embark on this journey though I wanted to give you a little context for why I\u2019m here and why the trail is here and maybe why you\u2019re here as well. \r\n\r\nFood has always been a big part of my life. \r\n\r\nI suppose that\u2019s kind of stupid thing to say, maybe you\u2019re having a \u201Cwell duh\u201D moment because food is an essential part of all of our lives. To quote the Poet Joy Harjo from \u201CPerhaps the World Ends Here or the Kitchen Table Poem\u201D \u201CNo matter what, we must eat to live.\u201D \r\n\r\nBut when the pandemic shutdown happened I was struck by the magnitude of my realization that food, for me, was so much more than life sustaining nourishment for my body. \r\n \r\nMy earliest memories are of making and eating food with my family. I remember my grandmother dragging a stool to her kitchen counter so I could peer over the mixing bowl and see butter and sugar and eggs whizzing around. I remember crumbling herbs into a spaghetti sauce with my mom, the fragrant aroma clinging to my tiny palms. I remember making my first full meal, from start to finish, and the sense of empowerment, pride, and joy that flooded me as my family sat down to enjoy the food together. \r\n\r\nAs I\u2019ve grown into an adult, food\u2019s place in my life has also grown. For years I hosted a standing Sunday dinner in my apartment with an open invitation for anyone to attend. When my grandmother died, I inherited her recipe box. The box overflows with beat up index cards, on which you\u2019ll find a mixture of typewritten and handwritten notes and stains tears and creases. On the recipe box is a post it note that she taped to the front that says in the shaky cursive of her old age \u201CSorry they are so beat up. Really used them, no time to fool around!\u201D When I use her recipes I feel her with me, I hear her voice, and when I share her food with my loved ones, her arms are wrapped around me and every other person at my table. \r\n\r\nDuring quarantine, my cooking and eating was reduced to physical nourishment and not much beyond that. Each day became a monotonous routine of eat, do the dishes, eat again. Etc etc etc. I\u2019m amazed at how many dishes on person eating three meals a day makes. During this time, I was found myself always hungry--starved for connection but I had completely lost my appetite for food. \r\n\r\nThis project was born of this moment. As I yearned for the connections that food and gathering provided in my life I started asking those around me to share their memories of meaningful childhood meals. In sifting through them I found that I was nourished in a way I had so longed for \u2013 sharing with those around me stories of what, and who, fed them was a way of feeding myself and cutting through the loneliness that left me feeling so empty. These little moments, these crumbs of lifetimes of food and experiences, piled up to become a full meal of connection. \r\n\r\nSo I now invite you, whoever and wherever you are, to wander through the accumulated crumbs. Take to the trail at your own pace. Skip or mosey. Make your own connections along the way. Here you will find memories of grandmothers and breakfasts and loss and celebration and ketchup and hot dogs and more. Oh my. \r\n\r\nThese memories and experiences may feel similar or different from your own. I hope that as you digest the crumbs you may ponder your own connections to food, and the connections that food, in turn, brings to you. What are the ways in which you nourish not just your body, but also your soul? \r\n\r\nThe final ingredient of this breadcrumb trail is \u2013 you. Throughout the journey, you will be given opportunities to add your own memory crumbs to the trail. If you choose to share a crumb, it will be sprinkled along the way and may help another wanderer find their way home on this journey. Oh, and before you embark, I want to thank you for being here.\r\n\r\nNow go ahead \u2013 follow the crumbs."
  },
  { title: "", 
    memory: "Description: The sound of a cracking egg.", 
    story: ""
  },
  { title: "CHILDHOOD MEAL", 
    memory: "Description: An audio track of overlapping voices of many people sharing memories of meaningful childhood meals with an instrumental underscore. Here, the audio track is presented as a poem. ", 
    story: "\ta favorite childhood meal\r\n\twhen I think of a childhood meal\r\n\tokay, childhood meal\r\nso what immediately comes to mind when you say\r\n\ta childhood meal that I\u2019m currently \r\nthinking of is something my dad would make\r\n\ta meal that I used to eat when I was a kid\r\nthat I\u2019ll always remember from my childhood\r\none of my most, uh, childhood memory meals that I recall\r\nthe childhood meal that I remember so very fondly\r\n\t\t(to describe)\r\n\twas even hard for me to think of it\r\nit\u2019s really describing a childhood experience\r\n\r\ncharoset\t\r\nmade by\t\t\tso my mom\r\nmy grandmother\twould make\twhen me \r\n\t\t\t\ttortillas\tand my mother\r\n\t\t\t\t\t\t\twould make snow cream\r\nthe macaroni and cheese\t\ttogether\r\nthat my mother used to make\r\n\t\t\t\t\t\t\t\t\r\n\tkept raising me\r\n\twhich I always\t\t\r\n\t\t\t\t\t\tit\u2019s this like chopped up \r\n\t\t\t\t\t\ttortilla cheese egg dish\r\nthere\u2019s a particular type\tthat was kind of made\r\nof barbecue chicken\t\tlike a *casserole*\t\r\n\r\n\t\tit\u2019s the way\r\n\t\tI ate constantly\t\t\tthat sometimes\r\n\t\tthrough my childhood\t\tI still eat\r\n\t\t\t\t\t\t\t\t(even though it\u2019s really gross)\r\n\t\t\t\t\t\t\t\tis the traditional\u2014\r\none of the traditional side dishes of Jamaican food is rice and peas\r\nwhich is basically white rice cooked in coconut milk with kidney beans\r\nand it\u2019s very good / that\u2019s not gross / but something \r\nwe used to do was put / ketchup on it / and it tastes, like\r\namazing\r\n\tit was a specialty of my mom\u2019s\r\nwe called it mac & cheese & hot dog coins\r\nshe would be the first to tell you she\u2019s not the best cook\r\nshe\u2019s also quite a picky eater, and I kind of was too as a kid\r\nby extension\r\n\t\t(I didn\u2019t even like hotdogs, just normally, in a bun)\r\n\tmy parents were separated my entire life, so\r\nmy mom was a really good cook and my dad was not\r\nwhenever we\u2019d be with my dad the meals were not a highlight\r\nbut something my dad did cook was this like chopped up\r\ntortilla cheese egg dish that was made / in like a casserole\r\n\tand growing up in the midwest, we knew a thing \r\nor two about casseroles, because I grew up \r\nin the midwest, and casseroles \r\nwere a huge part of where I came from\r\n\tand to me that is just the smell of love & comfort\r\njust smelling the pasta cooking was exciting in itself\r\nthere\u2019s a particular smell of the apples mixing with the wine \r\nmixing with the nuts / that is very distinctive / anytime I \r\nsmell cinnamon, which also goes into it\r\nI think of this particular dish / same with the smell\r\nwhen bacon was involved\r\nsometimes there was rosemary or thyme \r\non the chicken / it\u2019s the smell of birthdays \r\nand happy celebrations / coming home from school \r\nwalking into the house / taco meat cooking / but most of all\r\nto me they smelled like summer grilling season / like\r\nhome / like ketchup / which again I think the smell of ketchup\r\nis also really gross / I feel like I could always smell & hear them\r\nupstairs / you could hear / the moment the meat hit the grill\r\n& the beef started cooking / before long the smell would waft / upstairs\r\nI can remember feeling the hunger in my stomach before \r\neating / it was nothin\u2019 fancy / nothin\u2019 super technical / you know, \r\n\u201Cchef-worthy\u201D / but it tasted really good / as a kid\r\nmy mom would put the tater tots one to two inches apart\r\nall over the top / so it looked like a piece of art\r\nin my five-year-old mind / you weren\u2019t going \r\nto get anybody that hated it / you weren\u2019t \r\ngoing to get anybody that loved it\r\nand that was okay\r\n\r\n\tI loved it, we all loved it\r\n\tso how lucky were we?\r\n\tand spending a bunch of time with my mom\r\n\tit was just / one of life\u2019s / simple pleasures\r\n\ta simpler time / in my life / a loving experience\r\n\tsitting around the table / all eight of us\r\n\thow we made it work for ourselves / so\r\n\tI can\u2019t help but feel a little sad\r\n\twhen I think about it / my dad is no\r\n\tlonger around / it\u2019s been a long time\r\n\tsince my mom\u2019s been gone\r\n\tevery time I cook Portuguese tacos\r\n\tit feels good as well\r\n\tmy heart / she\u2019s with me\r\n\tI can feel her\r\n\tand it smells\r\n\tthe sweet smell of marshmallows\r\n\tand the texture is soft and smooth"
  },
  { title: "", 
    memory: "Description: The sound of whisking an egg in a bowl.", 
    story: ""
  },
  { title: "", 
    memory: "Description: The sound of pouring an egg into a frying pan.", 
    story: ""
  },
  { title: "Italian Beef Magic", 
    memory: "A memory of a secret recipe", 
    story: "My grandpa owned a successful Italian beef place in Chicago for 20-some years. The recipe was his own, which he never wrote down, nor did he measure anything. It was all sight,smell, and instinct… and a secret from his nine children. After he sold the business he continued making his beef only once a year, for Christmas. My many uncles, aunts, cousins, and I waited all year for the annual feast. One year an uncle notoriously fasted all day to \"make room,\" and then ate seven sandwiches in one sitting. My grandpa died several years ago. My grandma, who was in on the method, kept up the tradition for a couple years, and it was almost the same. She tried writing it down for my uncles, but they can’t recreate it. The full-fledged savory, herby, aromatic magic belonged only to my grandpa."
  },
  { title: "My Mom’s Tortillas", 
    memory: "", 
    story: "A favorite meal… (laughs) Yeah this one’s kind of my go to still today, but it’s one that I really enjoyed when I was younger. My mom used to always make flour tortillas and I still love them even though I now can’t eat gluten (laughs). But yeah my mom would make flour tortillas and we would have them all the time in different ways but my favorite ways were, there was one, there was one where she would put mayonnaise, she would salt mayonnaise, and put it on the tortilla, and we would just roll that up and eat it, just as is or just with butter. But the one that really really sticks with me is having scrambled eggs with little chopped up pieces of hot dog in a tortilla. And that was always a favorite and I know now, what I know now, is that it was because we didn’t have a lot of money, so it was sort of like poor food, but it’s still to me just like a go to. Now because I’m adult I’m just like “You know I’ll just like wilt a little bit of spinach and put it in there too.” (Laughs) But, yeah so I’ll still, I’ll still now, now I have to use corn tortillas because again, gluten (laughs,) but yeah, I’ll chop up hot dogs, do scrambled eggs, wilt some spinach in some butter and wrap it in a tortilla. It’s my absolute favorite."
  },
  { title: "", 
    memory: "Description: The sound of cereal being poured into a bowl.", 
    story: ""
  },
  { title: "Rajini’s Kitchen", 
    memory: "Description: In this audio track, we hear Upasna Barath cooking with her mother, Rajini. They are making a dish called pesarattu and discuss it while they cook.", 
    story: "TRANSCRIPT: \r\n\r\nUPASNA: Ok I have an idea, let\u2019s pretend we\u2019re on a cooking show. \r\nRAJINI: Ok\r\nsound of spatula hitting a bowl \r\nU: Ok, what would you say if you were on a cooking show? Hi--Oh I I know I know - I\u2019d be like \u201CHello everyone, welcome to Rajini\u2019s Kitchen. Rajini please tell us what you\u2019re cooking.\u201D \r\nR: I\u2019m making pesarattu. It is a type of pancake, but it\u2019s basically green lentil, blended. We add salt, chopped onions, green chilis and ginger, and some curry leaves and some herbs. \r\nU: Mmmmmmmm\r\nR: And then we make it like a pancake and add some ghee and oil mixed together, I try not to add too much ghee because it is very fatty.\r\nU: chuckles But it tastes good! \r\nR: And it tastes good. And what goes with it is this raw chutney, which is red onion, dry roasted red chilis, some brown sugar, and some salt and some tamarind. So you have sweet, sour, as well as spicy.\r\nU: Spicy mmmmmmm\r\nR: All three\r\nU: and then it\u2019s nice \u2018cause the green gram dosas kind of just like a, it\u2019s kind of mellow. It\u2019s a mellow flavor, kind of dry, and it soaks up the chutney, so then it just, it tastes so good.\r\nR: And it\u2019s protein packed! \r\nU: Yes! \r\nR: Well, this is what we had on Sunday and Saturday mornings. Now we\u2019re having it in the night! \r\nU: It\u2019s breakfast for dinner?\r\nSounds of sizzling\r\nR: Yeah. And it\u2019s perfect on rainy days like this. \r\nU: But I feel like a lot of Indian foods are breakfast for dinner. Like idli, dosa, pongal, \r\nR: Yeah but this is green gram dosa and it\u2019s very different. It can be eaten any time of the day. It\u2019s nourishing. \r\nU: What makes it so nourishing? \r\nR: \u2018Cause it has green gram. It\u2019s just like a green lentil. It\u2019s a--\r\nU: Hmmmm, and the healthy fat from the ghee? \r\nR: Yeah and it\u2019s protein packed, you know? It fills you up. And cumin is good for you too.\r\nBeeping of oven\r\nU: Oooh I have a question! Ok, who is your favorite TV, like uh, food TV show host?\r\nR: Sanjeev Kapoor! \r\nU: Ok, why do you like him? Why is he your favorite? And if you were to cook for him what would you cook for him?\r\nR: He makes mostly North Indian dishes, so I\u2019d make a South Indian dish.\r\nU: Like what? \r\nR: Mmmmm\u2026. Actually I would make this. \r\nU: What cooking show are we on again? Is that it? \r\nR: Rajini\u2019s kitchen.\r\nU: Oh yeah, I forgot! Laughs\r\nR: Laughs \r\nSound of beeping oven\r\nR: And it also reminds me of my, my, childhood days.\r\nU: Mmmm...\r\nR: It is my favorite breakfast. \r\nSound of a drawer closing.\r\nR: What are you thinking of? \r\nU: I\u2019m thinking about, - clears throat - sometimes the spice gets in the air and it makes me cough.\r\nR: Yeah, and the raw chutney is going to be hot. \r\nU: Ohhh, we\u2019ll see--\r\nR: And sweet, and--\r\nU: We\u2019ll see--\r\nR: and sour\r\nU: We\u2019ll see. I can handle it! \r\nR: All at the same time! \r\nU: Well, when I was in India, I liked this dosa in the morning but most of all I liked crispy dosas in the morning. \r\nR: Well this gets crispy too, the edges--\r\nU: It can--\r\nR: I\u2019ll make it crispy--\r\nU: Thanks mom! \r\nR: You\u2019re welcome. \r\nSound of cooking, TV in background, sink running, sizzling\r\nU: Mmmm, the pesarattu batter looks so cool and healthy. Cause it\u2019s green. Sizzle Ahh! Laughs that\u2019s satisfying.\r\nR: Yeah it is. \r\nSound of sizzling, TV in the background\r\nR: Ooooh, sizzle! Sizzle sizzle! \r\nU: Laughs \r\nR: But it\u2019s also getting burned and I don\u2019t want to burn anything. \r\nU: Ohh I\u2019ll have the little crispies from the pan, why not! Cooking sounds Why is the, why is the pesorat sticking to the pan? How do we--\r\nR: Well the first one always happens, it always happens to be--\r\nU: Mmmm, that\u2019s kind of like with any pancake I feel like--\r\nR: Yeah, the first one doesn\u2019t come out that good.\r\nU: Cause the pan\u2019s just like, warmin\u2019 up. You know, I\u2019ll have that one. That one looks pretty crispy. And Appa hates crispy.\r\nR: I mean he likes it.\r\nU: Yeah yeah sure. Sure sure sure sure. Laughs\r\nR: I mean he\u2019s hungry.\r\nU: Oooh is this cilantro? Is this for the chutney?\r\nR: No I already made the chutney.\r\nU: Oh, so why do we, why is this cilantro-- \r\nR: Well I\u2019m trying to like keep the leaves fresh so I\u2019m going to like take the leaves off the stalk and then put it in a box, maybe you could help me with that later? Just like take the leaves off the stems and like--\r\nU: Why not? \r\nR: And then wrap it in tissue paper, and then just store it in a tupperware.\r\nU: Why not?\r\nR: So it stays fresh and it doesn\u2019t darken and we don\u2019t waste anything. \r\nU: I got you. I\u2019ll do it.\r\nR: Okay \r\nU: Or maybe I won\u2019t. No I will I will don\u2019t worry. \r\nR: I know you\u2019re tired. \r\nU: Yeah. Today was a long day. But I\u2019m excited to have pesarattu. Wait, how many pesarattu(s) are appropriate to eat?\r\nR: I don\u2019t know. Three, four?\r\nU: I\u2019m going to go with four. Or until I feel full. But they\u2019re pretty good so--\r\nR: They\u2019re very addictive. \r\nU: Yes they are! \r\nR: You can\u2019t stop eating them. So how was your day? This play thing? \r\nU: Ummm\u2026 sound fades out"
  },
  { title: "Braces and Spaghetti", 
    memory: "A memory of an awkward meal", 
    story: "when i first got my braces it was the summer after 8th grade, and all i wanted to do right after was go over to my then-boyfriend's house. i went and his mom served spaghetti. his mom, him, and i all sat around the kitchen table and ate, but my brand-new braces and soreness from them made eating extremely difficult and visually uncomfortable. lots of spills and oopsies. i remember this meal because later that afternoon he said he had \"matured\" and dumped me."
  },
  { title: "", 
    memory: "Description: The sound of chopping onions.", 
    story: ""
  },
  { title: "Weekly Hamburgers", 
    memory: "", 
    story: "When I was a kid sometimes we would have hamburgers as my favorite childhood meal. It tasted a lot better than the hamburgers that you’d get at a fast food place or even like a restaurant. They were also a lot bigger, usually like a half pound size. I feel like I could always smell and hear them when they were being made. I'd be upstairs and when they were cooking you could hear the moment that the meat hit the grill and the beef started cooking, and before long the smell would waft upstairs and I can remember being very very hungry and I can remember feeling the hunger in my stomach before eating them. My dad would prepare these for me, when I was a kid, he was my parent who was home, and I remember feeling about that kind of a sense of constancy, familiarity, cuz i could count on that usually once a week or so, and that was just sort of like my favorite meal was sort of a basic thing my favorite meal was one I could have often."
  },
  { title: "", 
    memory: "Description: The sound of a hamburger sizzling", 
    story: ""
  },
  { title: "Eat the Evidence", 
    memory: "", 
    story: "One of my favorite food memories is making a ridiculously large amount of spritz cookies every year with my mother and grandmother. The cookies have a buttery, almondy flavor and just melt in your mouth. It makes me smile just thinking about them. We always make the dough with more almond extract than it calls for because if there’s one thing my family loves, it’s almond flavoring in desserts. Ever since I was old enough to help, my job has been to decorate the cookies with sprinkles, while my grandma makes the dough and my mom operates this ancient electric cookie press. The most important rule of baking for us is if a cookie breaks coming off the cookie sheet, we have to eat the evidence. I can’t count how many of these bite sized cookies we’ve split three ways over the years. I can practically hear the sighs of happiness as the cookies melted in our mouths. For me, making these cookies is such a joyful time filled with laughter and love, and creates an opportunity for the three of us to be together, slow down, and live in the moment. "
  },
  { title: "", 
    memory: "Description: The sound of popcorn popping", 
    story: ""
  },
  { title: "", 
    memory: "The sound of slicing bread", 
    story: ""
  },
  { title: "My Lunch", 
    memory: "", 
    story: "When I was 11 years old, I remember bringing for lunch to summer day camp, Korean food. And it was rice with an arrangement of different Korean side dishes, translated to banchan (\uBC18\uCC2C). And banchan, you would see at Korean restaurants, you go to such as tofu, kimchi, milchi (\uBA78\uCE58\uBCF6\uC74C)  which is basically anchovies with the same sort of red pepper seasoning you would have in kimchi and other things that I'm not quite sure, \u2018cause I\u2019m -- don't know how to make it yet. It's not straight up anchovy, but it's good. And I remember bringing the food for lunch one day and I was talking to the day camp counselor who didn\u2019t make fun of me for it, but they would just look and gawk at the almost, I guess, \u201Cexotic\u201D isn't the right word, but it's something that was different. It wasn't a peanut butter and jelly sandwich. It wasn't a ham and cheese sandwich. It was straight up rice, milchi, kimchi, maybe there were some vegetables in there and maybe bulgogi (\uBD88\uACE0\uAE30) which is basically another Korean beef dish that my mom made the night before. And some other kids too, they were just looking like, \u201Cwhat is that?\u201D Or they would just think it's so fancy, which is interesting because now I think about it, I'm kind of proud to have people think that it was interesting and fancy.\r\n\r\nBut it's also what I eat all the time. I think initially I thought I was--I felt a little embarrassed. I don't want to have the attention about my food, you know, a time when I'm supposed to just take in my own food and, and enjoy it when it's hard to do that, when everybody's staring at your food and looking at you and asking what this and that is, or \u201CWhy does it smell funny?\u201D \u201CWhy does it smell fishy?\u201D or \u201CThat smells bad\u201D or--it's, it's not the attention that you would want as an 11 year old. But now that I think about it, it's nice to know that people thought that food I was eating was\u2026 looked fancy and interesting, but it's really just a normal thing for me. And I hope that other people can realize that different cultured foods, it's a normal thing in America. Because America is more than just one race.\r\n"
  },
  { title: "", 
    memory: "Description: The sound of macaroni and cheese being stirred.", 
    story: ""
  },
  { title: "All Eight of Us Together", 
    memory: "", 
    story: "To describe a meaningful meal is a lot more than that. It\u2019s really describing a childhood experience. And what comes to mind first for me is the macaroni and cheese that my mother used to make for us. And just smelling the pasta cooking was exciting in and of itself. And it was really a very simple recipe with the sharp cheddar and campbells mushroom soup and milk, but um, the way that she made it, always in the large glass yellow pyrex bowl, um, it was just so comforting and smooth and creamy. \r\n\r\nI mean and you could smell that crust on top bubbling away. And we always had a salad with it with italian dressing and when you mixed the macaroni and cheese with some of that leftover italian dressing, it\u2019s just to die for. And to this day it\u2019s one of my most comforting meals. And I know as a child when we would have mac and cheese and salad, there was just a buzz around the table with all six kids, and my mom and dad. It was one of life\u2019s simple pleasures, and just a loving experience, sitting around the table all eight of us together. So that\u2019s my most meaningful childhood meal."
  },
  { title: "", 
    memory: "Description: The sound of pasta water boiling.", 
    story: ""
  },
  { title: "Even Though It’s Really Gross", 
    memory: "", 
    story: "So a meal that I used to eat when I was a kid that sometimes I still eat even though it’s really gross, um so the traditional, one of the traditional side dishes of Jamaican food is rice and peas which is basically white rice cooked in coconut milk with kidney beans, it’s very good, that’s not gross, but something we used to do was put ketchup on it, and it tastes like amazing. I don’t even know how to describe, you’ve got the coconut flavor, the kidney beans flavor, and there’s something that ketchup adds to this thing that is unbelievable especially considering how gross ketchup is. It smells like ketchup, which again I think the smell of ketchup is really gross, especially if you have Jamaican ketchup which is actually really good, it’s like there’s a special brand that they have that you can’t find anywhere in America but we would bring it up by the bottle when we came back from there but it’s like way more fresh and tomatoey than Heinz is and it’s really delicious. It kind of sounds like mac and cheese because it’s kind of wet, the sound of the spoon scraping the bowl too, it doesn’t look the most appealing because of the ketchup, but rice and peas does look appealing because the rice has turned kind of brown from the kidney beans. My mom would always make it, and she knew the right amount of ketchup to put on it, usually I would eat it regular, but if it was a snack that’s when we’d put the ketchup on it. Or like i remember one time on my birthday one year, when we still lived in Florida, we had a poll and we did a whole thing out there and I specially asked if I could have rice beans and ketchup for that because it’s really good. The feeling about my mom making it for me, I obviously took it for granted because I was little, but I also felt like she had to do it because she knew exactly how much ketchup to put on there, now when I make it it’s sort of special because it’s the sort of thing that like rice and peas don't actually have a recipe online, when I asked my mom how to make it when I tried to make it the first time many years ago, she didn’t really have a way of telling me except for you kind of use a little bit of that and a little bit of that, it doesn’t always turn out as good, but sometimes it turns out even better, so that’s my feeling, is that like I’ve conquered this thing. So yeah, that’s my childhood meal that is a little guilty pleasure that I’d still eat that is a little snack."
  },
  { title: "", 
    memory: "Description: The sound of chopping celery", 
    story: ""
  },
  { title: "", 
    memory: "", 
    story: "Know me for any period of time,\r\nand you know that I will cook for you\r\nIt is a rite of passage in the story of us\r\n\r\nSecrets are uttered here\r\n\u201CI\u2019ve never told anyone else,\u201D\r\nIs used more than sage\r\nMy favorite herb\r\n\r\nSomething about the rising heat\r\nBusy hands\r\nThe anticipation\r\nThey are appetizers for intimacy\r\n\r\nThere, in the nook between my stove and sink\r\nshe kissed me\r\nGroped at my waist from behind\r\nWhile I stirred with a wooden handle\r\n\r\nThat is when, distracted\r\nMy wrist brushed up against the pan\r\nFresh from the oven\r\n\r\nThat is when, distracted\r\nI ignored the wound\r\nTo satiate the hunger that followed\r\n\r\nThat is why, many months later\r\nThe scar remains\r\nAnd she does not"
  },
  { title: "", 
    memory: "Description: The sound of biting into an apple", 
    story: ""
  },
  { title: "Salty Girl", 
    memory: "", 
    story: "So a childhood meal that I used to have was chicken tetrazzini which I used to always confuse with chicken tortellini but it was called chicken tetrazzini. And it was basically like pasta with lots of butter and some parmesan cheese and a little bit of sherry or marsala wine and sauteed mushrooms and peas and roast chicken so it was like pasta chicken peas mushrooms but it always tasted really comforting and warm and i always remember tasting the mushrooms and I really liked getting to popped the peas. They were like ok vegetables if I had to eat a vegetable. I was cool with the mushrooms and the peas. It would smell very savory, sometimes there was rosemary or thyme on the chicken and a lot of times my mom would use bowtie pasta as a little kid which felt very festive, and the sound I associate with it are the pouring of the pasta and the pasta water into the strainer which I feel like was a big eruption of steam ad then this sort of like sloshing of pasta around, which to me like pasta out of water was  sort of like fish out of water and that was a strange texture, and it would be really warm and the butter would melt in the pasta and my mom would throw in mushrooms and peas,  and dice up the chicken in little squares and then there would be like a side of cheese, like parmesan cheese on top which always felt like a mound of snow. And my mom would prepare it for us, and I would always get scolded for putting too much salt or pepper on my pasta but it felt like my contribution to the meal so sometimes I went crazy but I'm a salty girl. I like salt. That is my chicken tetrazzini memory. "
  },
  { title: "Grilling Season and Home", 
    memory: "", 
    story: "There’s a particular type of barbecue chicken I ate constantly throughout my childhood. It wasn’t really barbecue chicken in terms of a barbecue sauce, it's really more of a marinated grilled chicken but we always called it barbecue. It’s a little bit blasphemous to real barbecue I'd say but delicious all the same. It was salty and zesty thanks to a tamari ginger marinade, they smelled like all the ingredients of course, but most of all to me they smelled like summer grilling season and home.\n\nThe meat was tender with a perfect grill on it and I preferred the wings, I would end up with marinade and charred bits all over my face looking really silly. You’d think that would mean that they weren’t food for company but we actually served it at every summer dinner party so the sounds of family and friends are in the background of all my memories of eating them. They were my dad’s creation, perfected over years of adjusting his recipe. They are his signature dish still, I actually requested them this summer and he made them for me and my partner the first time I brought him home. I tried to recreate them once but they didn’t even come close. Food is really powerful, and to me these wings mean comfort, family, carefree summers, joy - so I really hope I can get them right someday."
  },
  { title: "Love Potion with Shrimp Mosca’s", 
    memory: "", 
    story: "If I just get him sticky enough \r\nIf I just get the oil everywhere \r\nIf the bread is crusty enough\r\nAnd hot from the oven\r\nIf I fill the pyrex\r\nClear and raw like veined jelly\r\nHow else can I get someone to love me? \r\nSit across from him\r\nSuck the juices\r\nBe a piece of shell stuck to the cheek\r\nPeel twelve cloves of garlic\r\nThen double it\r\nInside my mouth there is a pink tongue\r\nA net that trawls for shrimp\r\nI catch everything\r\nSeaweed and plastic bottles, bags of Takis \r\nThere is so much trash\r\nThere are dead fish\r\nThe sun sets like my oven\r\nGlowing orange coils\r\nPink is the color of it\u2019s time\r\nHis hands smell like garlic\r\nMy mouth\r\nA gash of grease\r\nAll around me the water of want\r\nSpills over the levees\r\nHow will I know the potion worked? \r\nDesire is the long table\r\nCovered in shells\r\nThe two candles\r\nDripping wax"
  },
  { title: "", 
    memory: "Description: The sound of opening a can of tuna", 
    story: ""
  },
  { title: "Mindful Eating Exercise", 
    memory: "", 
    story: "Hello. My name is Natalia Buchanan and I'm a psychotherapist in private practice in Austin, Texas, and I specialize in eating disorders. Today, I will be taking you through a mindful eating exercise. This was developed out of Duke university's integrative medicine department. You can prepare for this exercise by choosing a special food to experience it with. Many people choose a raisin or a piece of chocolate or something that is delightful for you.\n\nPause the recording here to go retrieve your food.\n\nFirst: Take the food and hold it between your pointer finger and thumb. Bring your attention to it as if it were a novel item, imagining that you have never seen a raisin before in your life. Take the time to observe the raisin carefully. Really see it. Gaze at it with careful and full attention. Let your eyes explore every part of it.\n\nNotice its shape, colors and surfaces. Imagine its grooves where the light shines and shadows rotate and move the rays in between your fingers. Continuing to explore its texture. Apply a small bit of pressure to notice whether it's soft or hard. You might close your eyes if that helps you focus and enhances your sense of touch.\n\nSecond, recognizing this as a raisin, note any thoughts that you might have about raisins. Any memories about them or feelings of liking or disliking them. Hold the raisin under your nose and inhale naturally with each in breath. Notice any aroma or smell that arises, bring awareness also to any effect in your mouth or stomach.\n\nNow bring the raisin slowly up to your mouth, noticing how your hand and arm know exactly how and where to position it. Being aware if you are salivating as the mind and the body anticipate eating. Place the raisin gently into your mouth. Without yet chewing, hold the raisin in your mouth for at least 10 seconds, exploring it with your tongue, feeling the sensations of having it there.\n\nNotice this pause and how it feels to take some time before eating the raisin.\n\nWhen you are ready, prepare to chew the raisin. Take one or two bites and notice what happens, bringing your full attention to its taste and texture. As you continue chewing, take time to chew without swallowing. Noticing the taste and texture of the raisin in your mouth and how it may change over time. When you are ready to swallow the raisin, bring awareness to the sensation so that even this is experienced consciously.\n\nLastly, notice what is left of the raisin as you swallow and it travels down to your stomach. Notice how your body as a whole is feeling after completing this exercise. Yes.\n\nNow take a few moments to write down your reflections on the following questions.\n\nOne: How was this experience the same or different from how you normally eat?\n\nTwo: What, if anything, surprised you about the experience?\n\nThree: What did you notice with the raisin in terms of sight, touch, sound, smell, and taste.\n\nWhat thoughts or memories popped up while doing this exercise?\n\nFive: What is one tip for yourself that you are going to take from this experience to apply to your eating habits in the future?\n\nNow concludes the end of this mindful eating exercise."
  },
  { title: "Bartender’s Breakfast", 
    memory: "A memory of a food you wish you could eat again", 
    story: "I was traveling, and I was woken up in the middle of the night by a drunk person passing out in my bed. I left the room, waited until morning, and went to the bar on the ground floor of the hostel. The bartender offered me breakfast, which was a cheese-and-tomato toast and pint of Guinness. I wish I could time travel back to that moment."
  },
  { title: "", 
    memory: "Description: The sound of bacon sizzling", 
    story: ""
  },
  { title: "My Grandmother’s Charoset", 
    memory: "", 
    story: "So what immediately comes to mind when you say childhood meal is the preparation of charoset for passover, which is sort of a chopped apple walnut red wine sort of cold salad I suppose that goes on the Seder plate for Passover. It tastes sweet, it tastes tart, there’s a very particular smell of the apples mixing with the wine mixing with the nuts that is very distinctive. Anytime I smell cinnamon which always goes into it I always think of this particular dish. The sounds, I don’t know if there are any sounds that I associate with it, besides I guess my grandmother’s very thick Portuguese accent, thinking of the way she spoke and the way she made this particular dish is sort of what comes up for me. It looks sort of like a mishmash chopped apples red you kind of stain your fingers as you’re mixing it up. I always imagine, whenever I see chopped walnuts I think of this dish, it looks very sort of ground up and earthy, that was at least how she prepared it, it was very chunky. My feelings are fond, it takes me back to when my grandmother, as when I was a young young child, would visit my house she would make this and she would come in the spring time for passover etc. She died when I was eight, so this is like a really strong sensory memory from way back when, but it is overwhelmingly a positive one, and it was the first thing I thought of when you asked about an emotionally charged meal or food. So yeah, charoset, made by my grandmother. "
  },
  { title: "", 
    memory: "Description: The sound of a kitchen timer", 
    story: ""
  },
  { title: "Lima Beans", 
    memory: "", 
    story: "Mm. Mm. I mean, I think like that was her job. Like she really saw and wanted that to be her job. She told me once, like I don't, um, I never wanted, all I wanted was to be your mom. I never wanted some big career. And like, she--this was this conversation we had about feminism or whatever--and, um, she, so she loved, like just, she loved cooking and she loved making meals and she loved that being her thing. And so, yeah, there was also, okay, so she also used to serve lima beans, but like all of our vegetables were from the freezer section. And so it was like a bag of frozen lima beans. I fucking hated them. I couldn't stand them.\r\n\r\nAnd so, and you had to eat, you had to like finish your plate to be excused or whatever. And I couldn't stand lima beans. And so I would like put the spoon up to my mouth and like pour them into my hand and dump them under the table. And I don't know how I thought I was going to get away with that, but I was just like, and I was alone at the table at the end of the night.\r\n\r\nEveryone else had left and I wasn't allowed to leave because I had finished my plate. And so then I just started like dumping them under the table. Then my sister came in and like saw what I was doing and screamed like \u201CAndrea!\u201D and like told on me. So then my mom got really mad and gave me a whole other huge spoonful of lima beans.\r\n\r\nAnd it was like, \u201Cyou will sit there and you will finish those!\u201D And then I was crying and then I just would like put a little bite of lima beans in and then just drink a bunch of them milk. And I was just trying to like swallow them without chewing them. And then I just like cried through the rest of the meal and like ate as many lima beans as I could and went to bed."
  },
  { title: "Grandma Joyce’s Pasta", 
    memory: "", 
    story: "I remember going over to my best friend’s house when we were growing up and his grandmother – who, before long, I referred to as my grandmother since me and my best friend co-opted ourselves into one another’s families – before she became ill, would make the most particular meals. And we’d always eat them on paper plates. And as I grew up, I remember eating with him and three generations of his – my – family and feeling like this is what being in a family felt like. A kind of family structure that couldn’t be cleanly assumed between me and my single mom. I remember Grandma Joyce making Kool-Aid that, to this day, is my favorite thing to drink in the whole entire world. I will literally refuse to drink anyone else’s. You can’t call it Kool Aid if it isn’t made by Grandma Joyce. It’s a law. And I also remember one summer day in the grossest New York heat, Grandma Joyce made hot chocolate for me and Eli (another best friend/cousin) just because we asked for it. And we drank it shirtless, stupid, and sweating in the sun. The thing I carry the most, though, is something she would make really casually for lunch sometimes on a random weekday afternoon: pasta with canned salmon. Which I had never had anywhere but at her dining room table. It’s such a “we use what we have” kind of meal but when I moved to Texas and suddenly felt really far from her and from that sense of family. To remedy that distance, I started buying pasta and canned salmon and throwing it together again. I’ve tried different configurations and ratios and recipes. I season it differently every time. And while it never tastes like Grandma Joyce’s, I know what it’s aspiring to. And so whenever I make it, a small part of me does feel at home. There’s something so hospitable to me about this really obscure, really irreplicable elusive recipe of just pasta and salmon. Every time I have it, I get to think about Grandma Joyce and how grateful I am that I got to be a part of her family and have her as a part of mine for the years and years’ worth of sleepovers I spent at her house."
  },
  { title: "Flan for a Queen", 
    memory: "", 
    story: "Uh, growing up, we didn't have a lot of money. My mom was a student, my dad was a janitor and they were split up. So, um, didn't live with both of them anyway, but I do remember that affecting the kind of food that we ate. There just weren't really snack foods around. Everything that we ate was, was budgeted, my mom would make probably the same thing five nights a week. And then, I don't know. We might like go out to the local Mexican restaurant once a month, which was pretty inexpensive but really tasty. laughs And I just remember going to this Mexican restaurant and they all knew our name. It would be my mom, myself and my brother. And I would always get the cheese enchilada and I would get a flan. And even now I have such a good association with flan. I just associated it with luxury and like getting that one kind of special little treat. And you'd go out to eat, even though it's, you know, just like a local restaurant in a small town that has like plastic chairs and stuff. But, um, the, the one waitress who was one of the, one of the owners, she, she knew that I loved the flan and she would always come up and she would ask me if I wanted caramel or pecan that night. And, um, I remember it was a really big deal when I changed to wanting pecan. I felt very adult, but yeah, it's like a really happy memory I have of just feeling, feeling lavish and like I can order flan. What am I, a queen?"
  },
  { title: "", 
    memory: "Description: The sound of scraping out a can", 
    story: ""
  },
  { title: "Snow Cream", 
    memory: "", 
    story: "A favorite childhood meal would be when me and my mother would make snow cream together. So the way you make that is usually during the first fall of the season, first snowfall of the season, and for us, where we lived, it was usually the only snowfall of the season, we would go outside the day after, scrape off the top layer of snow off of cars and then scrape the rest of that snow into a bowl to take inside. And we would add milk and sugar and some vanilla extract into the snow and we would stir it all together and it sort of became this ice cream but it was also literally snow and it was just yummy delicious and was a beautiful memory. And I remember going to gather the snow and having my boots and crunching on the snow and remembering how bright everything was outside and spending a bunch of time with my mom and my mom telling me how this is what she used to do with her mom and her siblings. It just makes me think of a simpler time in my life and really cherished traditions that I hope to one day do with my family and maybe even my kids one day, making snow cream. "
  },
  { title: "", 
    memory: "Description: The sound of a pepper grinder", 
    story: ""
  },
  { title: "", 
    memory: "Description: An audio track of overlapping voices of many people sharing the secret ingredients of the food that nourished their physical and spiritual growth. Here, the audio track is presented as a poem. ", 
    story: "INGREDIENTS\r\n\r\negg, milk, butter, cheese\r\neggegg-egg   Miilk   butter / cheeeeeze\r\nbreadcrumbs?\r\n\r\negg eggmilk eggnoodles \r\nbutter milkcheee\r\n\tsseggnoodles cheeseheescheese\r\n\r\nvanilla extract\r\n\tbacon\r\nground beef, ground beef\r\ncinnamon, apple   sugar, walnut   peapeasppeas?\r\nmushrooms, mushrooms\r\nuh, red wine/sherry or like Marsala wine\r\nbaby carrots/arrots\r\ncelery and onions\r\nshallots / olives, black olives\r\nsalt(tortilla) pepprtortilla potato, tortillas tomatoes & chilies\r\n\tabalone steaks\r\n\u201Cketchup\u201D\r\n\t\tthe ketchup\r\nsalt, pepper, chicken\r\n\t /white rice/\nCampbells, uhmm, mushroom souupp\r\n\t\t /cream of mushroom soup/\r\n\r\nand my mom would prepare it for us\r\nmy dad would prepare these for me\r\nme and my mother would\r\nI did with my dad and my brother he would\r\nmy brothers and I loved it\r\nwith all six kids and my mom and dad\r\nmy family and maybe even my kids one day\r\nand then that\u2019s when my mom took over\r\nit\u2019s from my mom\r\nmy mom would make it\r\nmy mom prepared the meal\r\nthe fact that my mom prepared this special birthday dinner for me just\r\nthis is what her mom used to do with her and her siblings\r\neyy, everybody around the table\r\nsitting around the table / the love\r\nall eight of us together / in the kitchen and at the table when mom would prepare it\r\nthat we could all share together around the table\r\n\t\t\t\t\t\t\t\t/together/"
  }
]

var top_position = 920
var left_position = 75
var direction = 'left'
let tab_idx = 49

// let audio_url = "https://breadcrumbs-files.s3.us-east-2.amazonaws.com/"

let short_audios = {
  'audio1': new Audio(require("../Assets/Audio/egg-crack.mp3").default),
  'audio2': new Audio(require("../Assets/Audio/egg-whisk.mp3").default),
  'audio3': new Audio(require("../Assets/Audio/egg-fry.mp3").default),
  'audio4': new Audio(require("../Assets/Audio/cereal-pour.mp3").default),
  'audio5': new Audio(require("../Assets/Audio/chopping-onion.mp3").default),
  'audio6': new Audio(require("../Assets/Audio/burger-sizzle.mp3").default),
  'audio7': new Audio(require("../Assets/Audio/popcorn.mp3").default),
  'audio8': new Audio(require("../Assets/Audio/slicing-bread.mp3").default),
  'audio9': new Audio(require("../Assets/Audio/mac-n-cheese-stir.mp3").default),
  'audio10': new Audio(require("../Assets/Audio/water-boiling.mp3").default),
  'audio11': new Audio(require("../Assets/Audio/chopping-vegetables.mp3").default),
  'audio12': new Audio(require("../Assets/Audio/apple-chomp.mp3").default),
  'audio13': new Audio(require("../Assets/Audio/tuna-can-open.mp3").default),
  'audio14': new Audio(require("../Assets/Audio/bacon-sizzle.mp3").default),
  'audio15': new Audio(require("../Assets/Audio/kitchen-timer.mp3").default),
  'audio16': new Audio(require("../Assets/Audio/scraping-can.mp3").default),
  'audio17': new Audio(require("../Assets/Audio/pepper-grinder.mp3").default)
}

let long_audios = {
  1: new Audio(require("../Assets/Audio/Kristen.mp3").default),
  2: new Audio(require("../Assets/Audio/childhood-memory.mp3").default),
  3: new Audio(require("../Assets/Audio/Skidis.mp3").default),
  4: new Audio(require("../Assets/Audio/Upasna.mp3").default),
  5: new Audio(require("../Assets/Audio/Zach.mp3").default),
  6: new Audio(require("../Assets/Audio/Janice.mp3").default),
  7: new Audio(require("../Assets/Audio/Barb.mp3").default),
  8: new Audio(require("../Assets/Audio/Ranae.mp3").default),
  9: new Audio(require("../Assets/Audio/Justine.mp3").default),
  10: new Audio(require("../Assets/Audio/Rachel.mp3").default),
  11: new Audio(require("../Assets/Audio/Natalia.mp3").default),
  12: new Audio(require("../Assets/Audio/Daph.mp3").default),
  13: new Audio(require("../Assets/Audio/Andrea.mp3").default),
  14: new Audio(require("../Assets/Audio/Zoe.mp3").default),
  15: new Audio(require("../Assets/Audio/Braxton.mp3").default),
  16: new Audio(require("../Assets/Audio/outro-collage.mp3").default)
}

let background_audio = new Audio(require("../Assets/Audio/background-audio.mp3").default)

var large_crumbs = [LargeCrumb1, LargeCrumb2, LargeCrumb1, LargeCrumb1, LargeCrumb2, LargeCrumb1, LargeCrumb2, LargeCrumb2, LargeCrumb1, LargeCrumb2, AssortedClump, LargeCrumb2, LargeCrumb1, LargeCrumb2, LargeCrumb1, LargeCrumb2]

let play_crumbs = {
  1: LargeCrumb1Play,
  2: LargeCrumb2Play,
  3: AssortedClumpPlay
}

let pause_crumbs = {
  1: LargeCrumb1Pause,
  2: LargeCrumb2Pause,
  3: AssortedClumpPause
}

const keyboardUserCssClass = "keyboardUser"

var responses = []

class Landing extends Component {

  state = {
    modal_open: false,
    content_type: "",
    question_num: -1,
    story_num: -1,
    response: "",
    words_left: 100,
    response_submitted: false,
    currently_playing: -1,
    muted: true,
    last_audio_crumb_num: 1,
    modalWidth: '625px',
    background_started: false
  }

  componentDidMount() {
    this.interval = setInterval(this.getNewResponses, 500);
    document.body.style.backgroundColor = "#F9E0AC"

    /* Show blue outlines to interactive elements only if user is using
    keyboard accessibility mode */
    document.addEventListener("keydown", e => {
      if (e.key === "Tab") {
       this.setIsKeyboardUser(true);
      }
    });
    document.addEventListener("click", e => {
      this.setIsKeyboardUser(!e.screenX && !e.screenY);
    });
    
    document.addEventListener("mousedown", e => {
      this.setIsKeyboardUser(false);
    });

    if (!this.props.textMode) {
      var un_mute = document.getElementById('un-mute');

      if (un_mute !== null) {
        un_mute.onclick = () => {
          if (this.state.muted) {
            this.setState({ muted: false })
            background_audio.muted = false

            if (!this.state.background_started) {
              background_audio.play()
              background_audio.loop = true
              this.setState({background_started : true })
            }
          } else {
            this.setState({ muted: true })
            background_audio.muted = true
          }
        };
      }

      let promise = background_audio.play()
      if (promise !== undefined) {
        promise.then(_ => {
          // Autoplay of background audio is allowed
          background_audio.play()
          background_audio.loop = true
          this.setState({ muted: false })
          background_audio.muted = false
          this.setState({background_started : true })
        }).catch(error => {
          /* Autoplay of background audio is blocked. The user will manually
          have to click the speaker icon to start the audio */
        });
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  audioStarted(audio_name, crumb_num) {
    long_audios[audio_name].play()
    this.setState({ currently_playing : audio_name })
    large_crumbs[audio_name - 1] = pause_crumbs[crumb_num]
  }

  audioEnded(audio_name, crumb_num) {
    large_crumbs[audio_name - 1] = play_crumbs[crumb_num]
    this.setState({ currently_playing : -1 })
    if (this.state.background_started) {
      background_audio.play()
    }
  }

  setIsKeyboardUser(isKeyboard) {
    const { body } = document;
    if (isKeyboard) {
     body.classList.contains(keyboardUserCssClass) || body.classList.add(keyboardUserCssClass);
    } else {
     body.classList.remove(keyboardUserCssClass);
    }
  }

  getNewResponses = () => {
    // let audience_responses = await axios.get(api_url + "responses-all")

    // if (responses !== audience_responses.data) {
    //   responses = audience_responses.data
    // }

    responses = [
      {
          "approved":"true",
          "id":49,
          "question":3,
          "rank":1,
          "response":"Every Thanksgiving, my mom would make the most delicious banana pudding. Most of the time, she would have to make two big bowls of it because my grandfather could eat a whole bowl by himself. Banana pudding on Thanksgiving Day is my favorite food-related tradition in my household."
      },
      {
          "approved":"true",
          "id":44,
          "question":3,
          "rank":2,
          "response":"In Mexican culture, we typically eat tamales around Christmas time. For days, the women sit around the kitchen table and spread the masa on the corn husks. Then the dozens and dozens tamales get prepared and cooked for the holiday parties. The tamales will last for DAYS and you'll still be reheating tamales to eat on New Year's Day"
      },
      {
          "approved":"true",
          "id":45,
          "question":5,
          "rank":3,
          "response":"Never leave someone eating at the dinner table by themselves. Even if you're not eating, always keep them company. "
      },
      {
          "approved":"true",
          "id":48,
          "question":2,
          "rank":4,
          "response":"My mom definitely fed me the most; however, my paternal grandmother 's food always slapped."
      },
      {
          "approved":"true",
          "id":36,
          "question":1,
          "rank":5,
          "response":"My dad told me as a teen headed to college that any time I wanted to impress a girl, all I had to do was invite her over and have some onions and peppers cooking in a pan. That smell always makes me smile. "
      },
      {
          "approved":"true",
          "id":55,
          "question":4,
          "rank":6,
          "response":"Though the meal itself is nothing special, I would want to eat lunch with my friends in our high school cafeteria again. We would squeeze twelve people around a table meant for eight, discuss films and literature, and laugh together. Though the peanut butter and jelly wasn't great, I would love to travel back to those moments and spend more time with the people who influenced me so much!"
      },
      {
          "approved":"true",
          "id":66,
          "question":8,
          "rank":7,
          "response":"Just yesterday my boyfriend politely asked me if I would make some banana bread with dark chocolate chips and offered to help, he wanted to learn. We made some together, he mashed the bananas for me and gave me vanilla and cinnamon and let me crack the eggs because that's my favourite part about baking. The bread tasted incredible, it was made with love. The memory feels even sweeter than the bread was. "
      },
      {
          "approved":"true",
          "id":58,
          "question":3,
          "rank":8,
          "response":"During winter break my family and I make an obscene amount of Christmas cookies to my father's dismay. We spend days on Italian wedding cookies and Christmas M&M ones and candy cane twists and peanut butter kisses. Our kitchen is a mess for what feels like a week. When I lived in France we couldn't make nearly as many, American ingredients are expensive and hard to come by. We didn't  make as many in the variations we used to, but they tasted so much sweeter out of the oven because, after an autumn of struggles, we finally enjoyed cookies galore."
      },
      {
          "approved":"true",
          "id":103,
          "question":1,
          "rank":9,
          "response":"Is there anything more wonderful than the aroma of cinnamon wafting through the kitchen and into the home? It turns out there is: cinnamon plus cumin plus garlic. It is heavenly. I learned how to make picadillo from a recipe in a cookbook gifted to me and my spouse. Discovering the magical combination of these three spices was a turning point for us, and marks when we learned to truly dine, and not simply eat, together."
      },
      {
          "approved":"true",
          "id":67,
          "question":3,
          "rank":10,
          "response":"Back in the 40s my Grandfather found himself on Easter Sunday with an excess of decorated eggs and six restless kids. He made up a game called the 'Egg Cracking Contest': two opponents enter the 'ring',  holding the egg pointy-side-out with one hand behind their backs, and they crack their eggs together. The object is to crack the other person's egg while leaving your own intact, all while barraged with colorful commentary from the audience. This is played elimination style, with one champion at the end - but the real champion is the most entertaining competitor. Mimosas are also involved. "
      },
      {
          "approved":"true",
          "id":70,
          "question":6,
          "rank":11,
          "response":"My mother never cooked much. She didn't care much about food, the often said that 'food is just fuel.'  She had a few triumphs though: Hollandaise sauce, Chicken and Dumplings, Steak Sandwiches... she was ahead of her time regarding desserts, as she always doubled the salt in her chocolate chip cookies and used coffee instead of water in the brownie mix. \nI have her hand-written recipe for Hollandaise, and there is a dedicated step for reciting the Hail Mary as you pour the hot butter in the blender... praying that it won't congeal in to clumps... "
      },
      {
          "approved":"true",
          "id":75,
          "question":3,
          "rank":12,
          "response":"Every year for Hanukkah me and my mom try making latkes better than the year before. We're not very good at making latkes in the first place, and it's a pretty messy process (when we do it), so we dedicate a whole day to frying up some potato pancakes. I'm in charge of squeezing the juice from the shredded potatoes (so many potatoes, ow my arms), my mom does the frying, then I take over when she doesn't want to anymore. We end up burning most of them, give up, and try again next year. They're always tasty, though!"
      },
      {
          "approved":"true",
          "id":76,
          "question":4,
          "rank":13,
          "response":"A specific fried pickle... I miss you fried pickies. "
      },
      {
          "approved":"true",
          "id":82,
          "question":4,
          "rank":14,
          "response":"The arroz con avichuelas and chuleta my dad used to make me and my sister when my mom had to work late nights. I haven't had it since I was in middle school I think, because my dad passed away when I was in high school. I would give anything for that. My dad just knew how to cook the pork chop just right."
      },
      {
          "approved":"true",
          "id":90,
          "question":2,
          "rank":15,
          "response":"I love that my mom has a cookbook - she made it with her local women's club, and I'm so glad that I will still be able to have her recipes when I'm older. We still have a bunch of un-sold copies somewhere, but my favorite copy is the one where she has handwritten notes correcting her own recipes, or showing how to make half of a pancakes recipe on weekends for me and my sister to devour."
      },
      {
          "approved":"true",
          "id":91,
          "question":3,
          "rank":16,
          "response":"Every Christmas my sister, mom, and I would make Lebkuchen, which is a type of German gingerbread (and our only connection to our German heritage), which I thought was the best Christmas dessert in the world. I gave a box to my ex-boyfriend's family one year, but a week or so later I found the box, still full, on the table where I'd dropped it off, all the little squares hardened and inedible. I'm now more cautious about who I share my love for Lebkuchen with."
      },
      {
          "approved":"true",
          "id":102,
          "question":2,
          "rank":17,
          "response":"my mother - she was always making sure we had veggies, even if they were canned. And milk with dinner. Always milk with dinner."
      },
      {
          "approved":"true",
          "id":107,
          "question":2,
          "rank":18,
          "response":"my mother and she is a horrible cook! Just terrible and she doesn't know it. so we would have cold wet scrambled eggs for breakfast and gross shrimp casseroles and it was all done with love. Now when she makes Thanksgiving dinner we just marvel at how awful it is and laugh and eat it with love"
      },
      {
          "approved":"true",
          "id":111,
          "question":5,
          "rank":19,
          "response":"\"No books at the table!\""
      },
      {
          "approved":"true",
          "id":115,
          "question":7,
          "rank":20,
          "response":"When I was a kid I once got a marble stuck in my throat and for some reason, there was this little old lady - a curandera (witch doctor) at our house and she stuck her hand down my throat and pulled it out. So to this day, I can't be around spherical foods - like cherry tomatoes - without gagging."
      },
      {
          "approved":"true",
          "id":117,
          "question":2,
          "rank":21,
          "response":"When my mum would travel for work my dad would give me frozen mac and cheese wheels, yogurt, and apple sauce for dinner every night, whether it was for one night or over a week, and I loved it."
      },
      {
          "approved":"true",
          "id":127,
          "question":6,
          "rank":22,
          "response":"my grandma - i don't recall her voice, she was not one to speak much but I would watch her in the kitchen.  i was fascinated by her hands.  she was a farmer's wife and her hands were sooo smooth.  she made cheese, bread, canned vegetables, made pies, she was quite but confident and patient and she never pushed me away.  thank you grandma."
      },
      {
          "approved":"true",
          "id":130,
          "question":7,
          "rank":23,
          "response":"canned peas - oh my gosh, i buried them under mashed potatoes, i dropped them on the floor, i covered them in mustard, anything i could to make them disappear.  and i always had to finish them - oooh that mushyness was just not for me.  uuugh!"
      },
      {
          "approved":"true",
          "id":138,
          "question":5,
          "rank":24,
          "response":"Always...Always...ALWAYS, we had to wait until everyone was at the table to say GRACE and then the meal would begin. The GRACE was said in English. Then at the end of the meal, we would have to clear our own plate and collective say another prayer of thanks for having eaten. This would be said in Spanish. English for Father and Spanish for Mother. "
      },
      {
          "approved":"true",
          "id":139,
          "question":4,
          "rank":25,
          "response":"My grandma made the best fried chicken I've ever had (which isn't something you would expect to be top thing on a traditional Mexican-American woman's menu, right?) The last time she made it just for me was the day I came home after my first term at college 2000 miles away. Everyone was jealous. Because of dementia, she lost the ability to do it on her own soon after that, and then she passed away a few years ago. I think about her often, but especially when I'm eating some other fried chicken that just can't compete with hers."
      },
      {
          "approved":"true",
          "id":140,
          "question":8,
          "rank":26,
          "response":"My high school football coach shared his homemade banana bread with me in the film room! My coaches brought me in to help analyze film of our next opponent. This was a big deal. Usually our film sessions involved coaches using film they had already analyzed to explain our game plan. But this time it was like \"have some banana bread and help us figure out how to beat these guys.\" It had a huge impact on me; it made me believe that I was smart, responsible, and capable of contributing positively to anything, even beyond sports."
      },
      {
          "approved":"true",
          "id":135,
          "question":1,
          "rank":27,
          "response":"Freshly cut watermelon, summer time, family "
      },
      {
          "approved":"true",
          "id":145,
          "question":4,
          "rank":28,
          "response":"This potluck I went to my senior year in college. A professor had died of cancer. She requested that everyone bring their best dish to the meal and people went for it. It was the best meal I've ever had."
      },
      {
          "approved":"true",
          "id":148,
          "question":7,
          "rank":29,
          "response":"My parents' divorce. They told us over a special \"family meeting.\" We all made tea. It was the first time I drank tea. I didn't know what I was doing and so I ripped open the sachet and dumped the herbs in my mug of hot water. My sister laughed at me. My mom looked in it and said \"well that's one way to get all the flavor.\" Later I realized what an awful day it was for her and she was trying to make it feel better or special by having us make tea."
      },
      {
          "approved":"true",
          "id":153,
          "question":4,
          "rank":30,
          "response":"My great grandma's canned beef. It isn't a meal ... but I wish I could eat that again."
      },
      {
          "approved":"true",
          "id":52,
          "question":1,
          "rank":-1,
          "response":"My cousins live in Colorado and my family and I live in Texas, so we only see each other over the summer. When we visit, we celebrate all of our birthdays together since we can't be together on everyones' birthdays. My grandmother makes each of us a little cake and we sit and decorate them together. The smell of those cakes cooking is one that always brings joy, and I know I will never forget it."
      },
      {
          "approved":"true",
          "id":53,
          "question":2,
          "rank":-1,
          "response":"My mother is an incredible cook, and she likes to experiment with lots of dishes. She is fearless in the kitchen, and invents her own amazing recipes. I'm grateful that her attitude about cooking and food has affected my perspective."
      },
      {
          "approved":"true",
          "id":54,
          "question":3,
          "rank":-1,
          "response":"My dad is not a great cook - he literally can't boil water without burning a pan! But he does bake one thing every year: a cherry pie at Thanksgiving. My brothers and I always help him, and somehow, it always comes out perfect!"
      },
      {
          "approved":"true",
          "id":42,
          "question":1,
          "rank":-1,
          "response":"My abuela or my dad making coffee and pan dulce for me late at night while I did my homework in high school "
      },
      {
          "approved":"true",
          "id":43,
          "question":2,
          "rank":-1,
          "response":"Both of my parents were always working so I was typically being babysat by either of my abuelas. I think my paternal abuela fed me the most. "
      },
      {
          "approved":"true",
          "id":46,
          "question":7,
          "rank":-1,
          "response":"Grape Medicine "
      },
      {
          "approved":"true",
          "id":47,
          "question":1,
          "rank":-1,
          "response":"Freshly baked chocolate chip cookies."
      },
      {
          "approved":"true",
          "id":57,
          "question":2,
          "rank":-1,
          "response":"My mom used to help me pack my lunch in elementary school. She would put in a little note telling me good luck on my test or whatever I had going on that day with a little heart at the end. I would cut my carrots myself with this red knife and put them in Ziploc bags and my mom would make me a peanut butter and fluffernutter sandwich. She would tell me to remember my fruits and vegetables and would know if I didn't eat them, and I would then have them for dinner if not for lunch."
      },
      {
          "approved":"true",
          "id":41,
          "question":4,
          "rank":-1,
          "response":"I wish I could eat my abuela's Gorditas de azucar one last time"
      },
      {
          "approved":"true",
          "id":60,
          "question":1,
          "rank":-1,
          "response":"onions and garlic cooking in butter. can't be topped\n"
      },
      {
          "approved":"true",
          "id":56,
          "question":1,
          "rank":-1,
          "response":"The smell of banana bread on a chilly afternoon"
      },
      {
          "approved":"true",
          "id":39,
          "question":2,
          "rank":-1,
          "response":"Mama"
      },
      {
          "approved":"true",
          "id":50,
          "question":4,
          "rank":-1,
          "response":"My paternal grandmother's \"every day\" breakfast meal. She would make pancakes from scratch and scrambled eggs for my brother and I when we stayed the night. The most delicious breakfasts I have ever had."
      },
      {
          "approved":"true",
          "id":51,
          "question":5,
          "rank":-1,
          "response":"We really did not have many rules... I can only think of: \"Don't eat with your mouth open!\""
      },
      {
          "approved":"true",
          "id":59,
          "question":4,
          "rank":-1,
          "response":"After school in France, I would sometimes meet my family at McDonald's in the square down the street from my house. We would order on the kiosks because we couldn't speak French well yet and sit outside and munch on our memories of American food. Later that year I was taken out of school for a couple of weeks for mental health and for my earned outing we went to a McDonald's in the mall. I had a chicken sandwich, french fries, pomme frites sauce, and sprite. Nothing compares to the taste of home when you're sad. I was inlove."
      },
      {
          "approved":"true",
          "id":61,
          "question":2,
          "rank":-1,
          "response":"my mom, but also myself\n"
      },
      {
          "approved":"true",
          "id":38,
          "question":1,
          "rank":-1,
          "response":"My grandma's green beans - she would let them simmer for hours"
      },
      {
          "approved":"true",
          "id":65,
          "question":5,
          "rank":-1,
          "response":"we didn't eat at the table together! "
      },
      {
          "approved":"true",
          "id":64,
          "question":4,
          "rank":-1,
          "response":"during a difficult time in my life i found myself in paris for 3 days with $100 left to my name and i took myself to one nice dinner after only eating croissants and little sandwiches from the street carts every day. it was in a beautiful tucked a way restaurant that i randomly happened upon and had the best plate of spaghetti with such a delicious glass of wine. it felt good to be alone where no one knew me, eating by myself. i had so little material items but my life was rich"
      },
      {
          "approved":"true",
          "id":71,
          "question":1,
          "rank":-1,
          "response":"my mom making albondigas! "
      },
      {
          "approved":"true",
          "id":73,
          "question":2,
          "rank":-1,
          "response":"My mam\u00e1. We live far apart now, but I swear if she could feed me over the phone, she would. "
      },
      {
          "approved":"true",
          "id":74,
          "question":3,
          "rank":-1,
          "response":"Making tamales! "
      },
      {
          "approved":"true",
          "id":72,
          "question":1,
          "rank":-1,
          "response":"the smell of bacon in the oven"
      },
      {
          "approved":"true",
          "id":83,
          "question":1,
          "rank":-1,
          "response":"frying garlic and onions. best start to any meal"
      },
      {
          "approved":"true",
          "id":84,
          "question":2,
          "rank":-1,
          "response":"my mother making cookies for us after school. my favorite were oatmeal with butterscotch chips. Still makes them for me when I visit home :)"
      },
      {
          "approved":"true",
          "id":85,
          "question":1,
          "rank":-1,
          "response":"bacon\n"
      },
      {
          "approved":"true",
          "id":87,
          "question":1,
          "rank":-1,
          "response":"Cornbread"
      },
      {
          "approved":"true",
          "id":99,
          "question":3,
          "rank":-1,
          "response":"pastaaaaaa!!!!"
      },
      {
          "approved":"true",
          "id":63,
          "question":7,
          "rank":-1,
          "response":"These giant horse pills I had to take for some sickness I had. They were the biggest my mom had ever seen and 10-year-old me hated them with a passion. She would cut them in half for me and made me take them with Activia yoghurt and it absolutely ruined the taste for me. I can't eat yoghurt to this day because of it. "
      },
      {
          "approved":"true",
          "id":68,
          "question":4,
          "rank":-1,
          "response":"Sigh. When I lived in NYC I used to go to Zvi Gottheiner's Ballet class at City Center, and sometimes afterwards I would go to Bouchon Bakery in Columbus Circle (have they re-named that yet I wonder?). They have the BEST Salade Nicoise sandwich in incredible bread... and the BEST iced coffee... I would pick one of those up, walk across the circle to Central Park, sit and eat half of the sandwich and some incredible pastry they made. Those days were indulgent... the other half of the sandwich would have to be dinner... but whatever, 100% worth it. ;)"
      },
      {
          "approved":"true",
          "id":62,
          "question":6,
          "rank":-1,
          "response":"I have my father's talent for food, so by him cooking for me and exposing me to new foods (even if I hated them as a child), I have learned to use food in a way that makes myself and others happy. When we moved to France, there was no blue cheese, proper buffalo sauce, and the chicken wings were the tiniest I'd ever seen. My dad was so upset, we had to watch football games at weird times and with small wings and no blue cheese, utterly ruining a football tradition. We later mended it with the American embassy. "
      },
      {
          "approved":"true",
          "id":69,
          "question":5,
          "rank":-1,
          "response":"Everyone had to report on your day.  The entertainment value of your offering was more important than its factual accuracy... "
      },
      {
          "approved":"true",
          "id":77,
          "question":6,
          "rank":-1,
          "response":"My mom taught me to cook by touch, smell, and feel. I have no clue how to measure anything. I'm a good cook, but have a hard time following recipes!"
      },
      {
          "approved":"true",
          "id":78,
          "question":7,
          "rank":-1,
          "response":"brussel sprouts. my body rejects them. "
      },
      {
          "approved":"true",
          "id":79,
          "question":1,
          "rank":-1,
          "response":"The smell of huevo con chorizo that my mom makes me every time I come home to visit from college. Its warm, savory, and I can taste it the second I smell it. It makes the best sound, but nothing, not taste or sound, tops the smell. I miss it. It reminds me that she missed me. It reminds me that she loves me. And I love her too."
      },
      {
          "approved":"true",
          "id":80,
          "question":2,
          "rank":-1,
          "response":"My mother, she fed me almost everyday before I got old enough to start cooking for myself or for my little sister too. She has the best laugh. She doesn't like cooking, or she didn't before. I think she saw it as a chore then. Now she sends me pictures of the meals she makes that I can't eat. I think she has found joy in cooking for herself. And that makes me really happy."
      },
      {
          "approved":"true",
          "id":81,
          "question":3,
          "rank":-1,
          "response":"I started learning to bake recently, like really bake. So now, for any special holiday, I am in charge of desserts. My mother, watches and makes sure I dont go insane in the kitchen by chatting from the table and occasionally hand washing things I will need again when I'm not looking. My little sister, stays hidden until the bake is ready, devours it, and then is on dishes duty as her payment for my treat. We've been doing this for most holidays, or even just my visits, for the past almost two years. It's nice."
      },
      {
          "approved":"true",
          "id":86,
          "question":2,
          "rank":-1,
          "response":"My grammy Heckner"
      },
      {
          "approved":"true",
          "id":89,
          "question":1,
          "rank":-1,
          "response":"Its aroma of chocolate wafting through the air and landing straight on my nose. "
      },
      {
          "approved":"true",
          "id":98,
          "question":1,
          "rank":-1,
          "response":"my Mom frying something in her cast iron fry pan - it could be bacon, round steak, pork chops - it didn't matter what it was. Tantalizing smells from that pan wafted through the house and fed her 6 hungry children that were growing by leaps and bounds.  "
      },
      {
          "approved":"true",
          "id":92,
          "question":4,
          "rank":-1,
          "response":"When I was studying abroad my friends and I would always go to late night food stands or fast food places where we could get crispy French fries in a cone, doused in tangy andalouse sauce, which we would eat with these tiny, cute 2-tonged plastic forks. Or, my favorite option was to throw these fries and sauce onto a baguette sandwich or a wrap, and there's something about fries in a sandwich that feels really indulgent and warms you up after a long night and that still makes me really nostalgic"
      },
      {
          "approved":"true",
          "id":93,
          "question":5,
          "rank":-1,
          "response":"We would never say grace before eating when I was growing up. We only started recently because my grandmother started going to church again after my granddad passed, and even though she's always been very anti-establishment and anti-religion, my mom is very committed to praying with my grandmother. I don't know if she's a believer now, or if she just does it to make my grandmother feel better, but it seems like a strange break of tradition from my childhood, when we ate when the food was warm instead of waiting."
      },
      {
          "approved":"true",
          "id":94,
          "question":7,
          "rank":-1,
          "response":"Very literally - waffles. My mom would make them for me and my sister along with the most amazing hommemade syrup and I would just inhale them. I knew I had to stop when I couldn't stuff any more in my mouth and had to wait until I felt them roll down my throat, through my chest, and into my stomach."
      },
      {
          "approved":"true",
          "id":95,
          "question":1,
          "rank":-1,
          "response":"A good cup of regular or earl gray tea with a bit of milk. Whenever I drink it - morning, noon, night - I feel like I'm coming to life again."
      },
      {
          "approved":"true",
          "id":96,
          "question":6,
          "rank":-1,
          "response":"My mom likes to send \"virtual care packages\" to her college girls, me and my sister, which are basically pictures of homemade food. Although I know she means well, they always make me so hungry and I just get really jealous that she's eating what's in the picture and I'm not."
      },
      {
          "approved":"true",
          "id":97,
          "question":6,
          "rank":-1,
          "response":"My aunt taught me most little things I make now. She taught me to make a fried egg at 8! It's one of my favorite things, and I think the first thing I ever learned to cook on a stove. "
      },
      {
          "approved":"true",
          "id":100,
          "question":1,
          "rank":-1,
          "response":"Buttter"
      },
      {
          "approved":"true",
          "id":101,
          "question":1,
          "rank":-1,
          "response":"hot chocolate chip cookies baking in the oven"
      },
      {
          "approved":"true",
          "id":104,
          "question":3,
          "rank":-1,
          "response":"Cookies are a strong tradition in my family - we make our grandmother's cookie recipes at the holidays. I love to decorate my cookies just as my grandmothers had done - with sprinkled colored sugars. However, I grew up painting cookies with my mom and sister. We used egg yolks, dyed with food coloring.  It's a process that is creatively absorbing, and the results are fantastic, colorful, and shiny. "
      },
      {
          "approved":"true",
          "id":105,
          "question":1,
          "rank":-1,
          "response":"blueberry muffins !"
      },
      {
          "approved":"true",
          "id":106,
          "question":1,
          "rank":-1,
          "response":"red chili filling the house with New Mexico and my marriage and celebrating my wife's happiness and our weird family and a flavor that is not for everyone but is for us"
      },
      {
          "approved":"true",
          "id":108,
          "question":3,
          "rank":-1,
          "response":"fridays at our house are pizza nights and the family cuddles up and watches a movie all together... "
      },
      {
          "approved":"true",
          "id":40,
          "question":3,
          "rank":-1,
          "response":"Eating chicken wings and watching \"How to Lose a Guy in 10 Days\". I don't know why, but every time we ordered wings I would watch that movie!"
      },
      {
          "approved":"true",
          "id":116,
          "question":1,
          "rank":-1,
          "response":"Waking up to the smell of apples covered in cinnamon baking in the oven"
      },
      {
          "approved":"true",
          "id":109,
          "question":4,
          "rank":-1,
          "response":"French Onion Soup in Paris at dawn after a night of dancing dancing dancing"
      },
      {
          "approved":"true",
          "id":112,
          "question":7,
          "rank":-1,
          "response":"teaching my son and daughters to swallow pills was hard!!!!\n"
      },
      {
          "approved":"true",
          "id":113,
          "question":1,
          "rank":-1,
          "response":"My mom's bread, right before it came out of the oven."
      },
      {
          "approved":"true",
          "id":114,
          "question":2,
          "rank":-1,
          "response":"My mom. She fed me, my adult brothers - even when they were grown-ass men with their own kids, every weekday morning - for years and years and years - they'd leave their homes, strive to my Mom's, and she would make them fresh tortillas, fried eggs and red chili."
      },
      {
          "approved":"true",
          "id":122,
          "question":1,
          "rank":-1,
          "response":"fresh bread, specifically my great, great aunt's german potato rolls,"
      },
      {
          "approved":"true",
          "id":118,
          "question":3,
          "rank":-1,
          "response":"Every time I visit my grandmother we go to Northwestern Steakhouse. We all always get the ladies filet with a side salad and get a side of spaghetti, which comes with a mountain of cheese and drenched in the same buttery juice as the steak. "
      },
      {
          "approved":"true",
          "id":119,
          "question":4,
          "rank":-1,
          "response":"This pasta dish I had in Amsterdam where the pasta was tossed inside of a parmesan cheese wheel with olive oil and a little bit of a truffle, and then was heated until the cheese started to melt and became the sauce. "
      },
      {
          "approved":"true",
          "id":120,
          "question":6,
          "rank":-1,
          "response":"I was making waffles with my mum when I was little and she had me fold the beaten egg whites into the egg yolks, which I did very aggressively, while my parent's best friend looked on in horror as I beat all of the air out of the egg whites. He very kindly intervened and taught me how to gently fold in the egg whites before I completely wrecked the batter. I always think about this moment when I'm folding in egg whites, especially for waffles."
      },
      {
          "approved":"true",
          "id":121,
          "question":7,
          "rank":-1,
          "response":"Broccoli and brussels sprout casserole after eating it 8 days in a row"
      },
      {
          "approved":"true",
          "id":123,
          "question":2,
          "rank":-1,
          "response":"my mom - she is excellent at making something out of seemingly nothing - she'd take a few ingredients and magically come up with a meal that brought comfort and a feeling of satisfaction.  she still has the skill to make more with less.  i love my mom.  "
      },
      {
          "approved":"true",
          "id":124,
          "question":3,
          "rank":-1,
          "response":"as a kid, on saturdays, my family would watch creature double feature while eating hotdogs, baked beans, and thin salted potato chips.  "
      },
      {
          "approved":"true",
          "id":125,
          "question":4,
          "rank":-1,
          "response":"Karelian pies - a finnish pasty- also known as riisi pirraka - sooooooo good"
      },
      {
          "approved":"true",
          "id":126,
          "question":5,
          "rank":-1,
          "response":"hands and elbows off the table - no leaning"
      },
      {
          "approved":"true",
          "id":128,
          "question":1,
          "rank":-1,
          "response":"baked beans (onions, bacon, and brown sugar)"
      },
      {
          "approved":"true",
          "id":133,
          "question":2,
          "rank":-1,
          "response":"My dad can't eat gluten and when I was little he got really obsessed with finding the perfect rice.  I have a lot of memories of him making different kinds of rice and us all trying it."
      },
      {
          "approved":"true",
          "id":132,
          "question":1,
          "rank":-1,
          "response":"Pumpkin pie in the oven."
      },
      {
          "approved":"true",
          "id":134,
          "question":3,
          "rank":-1,
          "response":"Strawberries and cream on May Day."
      },
      {
          "approved":"true",
          "id":136,
          "question":4,
          "rank":-1,
          "response":"My grandma's dill bread "
      },
      {
          "approved":"true",
          "id":137,
          "question":7,
          "rank":-1,
          "response":"My adderall in the morning because I swallow it dry because I'm lazy "
      },
      {
          "approved":"true",
          "id":131,
          "question":8,
          "rank":-1,
          "response":"my dad's parents, my paternal grandparents were small-hold farmers. my grandpa was also a carpenter and donut delivery fellow.  i think he chose the donut delivery job so that he could enjoy a donut every now and again and so he could share donuts with the family.  grandma was a one-room schoolhouse teacher before marrying grandpa.  rules back them banned women from teaching once married so once she was married, it was farming/gardening, home keeping, child rearing, and social gatherings with friends and at church.  i believe my love of gardening is directly related to grandma and grandpa.  "
      },
      {
          "approved":"true",
          "id":142,
          "question":1,
          "rank":-1,
          "response":"something cooking in toasted sesame oil with heavy notes of cumin and garlic...this could cover a lot of different dishes."
      },
      {
          "approved":"true",
          "id":143,
          "question":2,
          "rank":-1,
          "response":"My mom. She was a home-ec major in college. She took pride in making well-rounded and \"nutritious\" meals. Even today she is constantly finding new recipes, but they area ll based around simplicity and using canned or frozen food. I hate that I've become a food snot that thinks about that sort of thing, because I love being fed."
      },
      {
          "approved":"true",
          "id":144,
          "question":3,
          "rank":-1,
          "response":"Egg and sausage casserole on Christmas morning. Served with a mushroom-sherry sauce. I try to make this when I'm not with my family, but it never tastes as good."
      },
      {
          "approved":"true",
          "id":149,
          "question":1,
          "rank":-1,
          "response":"My nana made the BEST chicken strips and mashed potatoes with gravy. She would make everything from scratch and was famous for it. The best smell was when she would fry the chicken and the scent of toasted flour and fried chicken would waft through the kitchen."
      },
      {
          "approved":"true",
          "id":146,
          "question":5,
          "rank":-1,
          "response":"Don't chew with your mouth open! Clear your own dishes. Ask if you can have seconds."
      },
      {
          "approved":"true",
          "id":147,
          "question":6,
          "rank":-1,
          "response":"My boyfriend is trying to teach me..but I'm not super interested. I'd rather eat his amazing cooking! but my grandmother taught me to bake. We baked lemon bars. Every time I use a knife to level off a cup of flour I think of her showing me how to do that."
      },
      {
          "approved":"true",
          "id":150,
          "question":1,
          "rank":-1,
          "response":"When my mom and I bake Christmas cookies, it fills the whole house with the smell of butter and powdered sugar and gooey chocolate and candied ginger. It smells like Christmas, which has always been my favorite time of year. It also meant my mom and I would decorate Christmas cookies together!"
      },
      {
          "approved":"true",
          "id":151,
          "question":1,
          "rank":-1,
          "response":"it's either garlic anything oorrr sugar cookies around Christmas time."
      },
      {
          "approved":"true",
          "id":152,
          "question":3,
          "rank":-1,
          "response":"latkes and my great-grandma's recipe for blintzes on the first night of Hanukkah // dried beef sandwiches on christmas eve because it was delicious but also REALLY EASY to clean up so we could immediately open presents // pizza rolls on NYE"
      }
    ]

    top_position = 920
    left_position = 75
    direction = 'left'
  }

  onClickLongAudio = (audio_name, crumb_num) => {
    if (this.state.currently_playing === -1) {
      background_audio.pause()
      this.audioStarted(audio_name, crumb_num)

      long_audios[audio_name].onended = function() {
        this.audioEnded(audio_name, crumb_num)
      }.bind(this)
    } else {
      if (this.state.currently_playing === audio_name) {
        long_audios[audio_name].pause()
        this.audioEnded(audio_name, crumb_num)
      } else {
        long_audios[this.state.currently_playing].pause()
        large_crumbs[this.state.currently_playing - 1] = play_crumbs[this.state.last_audio_crumb_num]

        this.audioStarted(audio_name, crumb_num)

        long_audios[audio_name].onended = function() {
          this.audioEnded(audio_name, crumb_num)
        }.bind(this)
      }
    }
    this.setState({ last_audio_crumb_num : crumb_num })
  }

  onClickShortAudio = (audio_name) => {
    short_audios[audio_name].play()
  }

  showText(story_num) {
    this.setState({ modal_open : true, content_type: 'text', story_num: story_num })
    if (story_num === 3) {
      this.setState({ modalWidth: '705px'})
    } else if (story_num === 40) {
      this.setState({ modalWidth: '815px'})
    } else {
      this.setState({ modalWidth: '625px'})
    }
  }

  showQuestion(question_num) {
    this.setState({ modal_open : true, content_type: 'question', question_num: question_num, words_left: 100})
  }

  submitResponse(question_num, response) {
    // axios
    // .get(api_url + "response-add", {
    //   params: {
    //     question: question_num,
    //     response: response
    //   }
    // })
    this.setState({ response_submitted : true })
  }

  wordsLeft(response) {
    response = response.replace(/(^\s*)|(\s*$)/gi,"")
    response = response.replace(/[ ]{2,}/gi," ")
    response = response.replace(/\n /,"\n")

    var words_left

    if (response === "") {
      words_left = 100
    } else {
      words_left = 100 - response.split(' ').length;
    }

    return words_left
  }

  getLeftPosition = () => {
    if (left_position === 15) {
      left_position = 30
      direction = 'right'
    } else if (left_position === 75) {
      left_position = 60
      direction = 'left'
    } else {
      if (direction === 'left') {
        left_position -= 15
      } else {
        left_position += 15
      }
    }

    return left_position
  }

  getTopPosition = (type) => {
    if (type === "crumb") {
      top_position += 10
    } else if (type === "header") {
      top_position += 25
    } else if (type === "header-space") {
      top_position += 15
    } else if (type === "footer-space") {
      top_position += 30
    } else {
      top_position += 7
    }
    return top_position
  }

  getTabIdx = () => {
    tab_idx += 1
    return tab_idx.toString()
  }

  render() {
    return (
      <div>
        <img src={Title} className="title-text" alt=""/>
        <p className="welcome-text">feel free to wander...</p>

        {/* Button to switch between text and traditional mode */}
        {this.props.textMode || 
          <div>
            <div style={{position: 'fixed', top: '85vh', left: '90vw', display: this.state.currently_playing === -1 ? "" : "none"}} id="un-mute">
              {this.state.muted ? <FontAwesomeIcon icon={faVolumeMute} size="4x" /> : <FontAwesomeIcon icon={faVolumeUp} size="4x" />}
            </div>
            <Button tabIndex="1" variant="flat" style={{position: 'absolute', top: '1vh', left: '0.5vw', backgroundColor: '#B6BDBE', borderRadius: '25px', width: '150px'}} onClick={() => window.location.href="/text-trail"}>
              <FontAwesomeIcon icon={faDeaf} size="1x" color="white"/>
              <p className="button-text">click here for a readable experience</p>
            </Button>
          </div>
        }
        {!this.props.textMode || 
          <Button tabIndex="1" variant="flat" style={{position: 'absolute', top: '1vh', left: '0.5vw', backgroundColor: '#B6BDBE', borderRadius: '25px', width: '150px'}} onClick={() => window.location.href="/trail"}>
          <FontAwesomeIcon icon={faAssistiveListeningSystems} size="1x" color="white"/>
            <p className="button-text">return to the traditional experience</p>
          </Button>
        }

        {(this.state.background_started || this.state.currently_playing !== -1 || this.props.textMode ) || 
          <p className="background-audio-text" style={{top: '64vh', left: '90vw'}}>click the speaker icon to start the background audio</p>
        }

        {/* Non-Crumb Decorations */}
        <img src={BlueBird} className="bird" style={{top: '51vh', left: '71vw'}} alt=""/>
        <img src={SmallRock} className="small-rock" style={{top: '166vh', left: '78vw'}} alt=""/>
        <img src={PinkBird} className="bird" style={{top: '251vh', left: '10vw'}} alt=""/>
        <img src={LargeRock} className="large-rock" style={{top: '332vh', left: '67vw'}} alt=""/>
        <img src={GreenBird2} className="bird" style={{top: '407vh', left: '72vw'}} alt=""/>
        <img src={Plant1} className="plant" style={{top: '510vh', left: '7vw'}} alt=""/>
        <img src={Plant2} className="plant" style={{top: '782vh', left: '74vw'}} alt=""/>

        <img src={SmallCrumb1} className="small-breadcrumb" style={{top: '35vh', left: '75vw'}} alt=""/>
        <img src={SmallCrumb2} className="small-breadcrumb" style={{top: '41vh', left: '65vw'}} alt=""/>
        <img src={SmallCrumb1} className="small-breadcrumb" style={{top: '43vh', left: '54vw'}} alt=""/>
        <img src={SmallCrumb3} className="small-breadcrumb" style={{top: '47vh', left: '40vw'}} alt=""/>
        <img src={SmallCrumb1} className="small-breadcrumb" style={{top: '53vh', left: '28vw'}} alt=""/>

        {/* Crumb 1: Long Audio */}
        {this.props.textMode || 
          <img tabIndex="2" onKeyPress={() => this.onClickLongAudio(1, 1)} src={large_crumbs[0]} onClick={() => {this.onClickLongAudio(1, 1)}} className="ex-large-interactive-breadcrumb" style={{top: '49vh', left: '9vw'}} alt="Breadcrumb 1"/>
        }
        {!this.props.textMode || 
          <img tabIndex="2" onKeyPress={() => {this.showText(1)}} src={LargeCrumb1} onClick={() => {this.showText(1)}} className="ex-large-interactive-breadcrumb" style={{top: '49vh', left: '9vw'}} alt="Breadcrumb 1"/>
        } 
        <img src={SmallCrumb3} className="small-breadcrumb" style={{top: '69vh', left: '28vw'}} alt=""/>
        <img src={MediumCrumb1} className="medium-breadcrumb" style={{top: '70vh', left: '41vw'}} alt=""/>

        {/* Crumb 2: Short Audio */}
        {this.props.textMode || 
          <img tabIndex="3" onKeyPress={() => this.onClickShortAudio("audio1")} src={SmallCrumb2} onClick={() => {this.onClickShortAudio("audio1")}} className="small-interactive-breadcrumb" style={{top: '80vh', left: '56vw'}} alt="Breadcrumb 2"/>
        }
        {!this.props.textMode || 
          <img tabIndex="3" onKeyPress={() => {this.showText(2)}} src={SmallCrumb2} onClick={() => {this.showText(2)}} className="small-interactive-breadcrumb" style={{top: '80vh', left: '56vw'}} alt="Breadcrumb 2"/>
        } 
        <img src={SmallCrumb3} className="small-breadcrumb" style={{top: '79vh', left: '66vw'}} alt=""/>

        {/* Crumb 3: Long Audio */}
        {this.props.textMode || 
          <img tabIndex="4" onKeyPress={() => {this.onClickLongAudio(2, 2)}} src={large_crumbs[1]} onClick={() => {this.onClickLongAudio(2, 2)}} className="large-interactive-breadcrumb" style={{top: '73vh', left: '75vw'}} alt="Breadcrumb 3"/>
        }
        {!this.props.textMode || 
          <img tabIndex="4" onKeyPress={() => {this.showText(3)}} src={LargeCrumb2} onClick={() => {this.showText(3)}} className="large-interactive-breadcrumb" style={{top: '73vh', left: '75vw'}} alt="Breadcrumb 3"/>
        }
        <img src={SmallCrumb3} className="small-breadcrumb" style={{top: '93vh', left: '64vw'}} alt=""/>
        <img src={MediumCrumb2} className="medium-breadcrumb" style={{top: '95vh', left: '52vw'}} alt=""/>

        {/* Crumb 4: Short Audio */}
        {this.props.textMode || 
          <img tabIndex="5" onKeyPress={() => this.onClickShortAudio("audio2")} src={SmallCrumb2} onClick={() => {this.onClickShortAudio("audio2")}} className="small-interactive-breadcrumb" style={{top: '105vh', left: '42vw'}} alt="Breadcrumb 4"/>
        } 
        {!this.props.textMode || 
          <img tabIndex="5" onKeyPress={() => {this.showText(4)}} src={SmallCrumb2} onClick={() => {this.showText(4)}} className="small-interactive-breadcrumb" style={{top: '105vh', left: '42vw'}} alt="Breadcrumb 4"/>
        } 
        <img src={MediumCrumb1} className="medium-breadcrumb" style={{top: '103vh', left: '26vw'}} alt=""/>

        {/* Crumb 4.5: Short Audio */}
        {this.props.textMode || 
          <img tabIndex="6" src={SmallCrumb1} onKeyPress={() => this.onClickShortAudio("audio3")} onClick={() => {this.onClickShortAudio("audio3")}} className="small-interactive-breadcrumb" style={{top: '115vh', left: '14vw'}} alt="Breadcrumb 5"/>
        }
        {!this.props.textMode || 
          <img tabIndex="6" src={SmallCrumb1} onKeyPress={() => {this.showText(5)}} onClick={() => {this.showText(5)}} className="small-interactive-breadcrumb" style={{top: '115vh', left: '14vw'}} alt="Breadcrumb 5"/>
        }
        <img src={SmallCrumb2} className="small-breadcrumb" style={{top: '126vh', left: '28vw'}} alt=""/>
        <img src={SmallCrumb3} className="small-breadcrumb" style={{top: '127vh', left: '42vw'}} alt=""/>

        {/* Crumb 5: Text */}
        <img tabIndex="7" onKeyPress={() => {this.showText(6)}} src={MediumCrumb2} onClick={() => {this.showText(6)}} className="medium-interactive-breadcrumb" style={{top: '127vh', left: '52vw'}} alt="Breadcrumb 6"/>
        <img src={SmallCrumb1} className="small-breadcrumb" style={{top: '136vh', left: '66vw'}} alt=""/>

        {/* Crumb 6: Long Audio */}
        {this.props.textMode || 
          <img tabIndex="8" onKeyPress={() => this.onClickLongAudio(3, 1)} src={large_crumbs[2]} onClick={() => {this.onClickLongAudio(3, 1)}} className="large-interactive-breadcrumb" style={{top: '131vh', left: '72vw'}} alt="Breadcrumb 7"/>
        }
        {!this.props.textMode || 
          <img tabIndex="8" onKeyPress={() => {this.showText(7)}} src={LargeCrumb1} onClick={() => {this.showText(7)}} className="large-interactive-breadcrumb" style={{top: '131vh', left: '72vw'}} alt="Breadcrumb 7"/>
        }
        <img src={SmallCrumb2} className="small-breadcrumb" style={{top: '152vh', left: '65vw'}} alt=""/>
        <img src={SmallCrumb3} className="small-breadcrumb" style={{top: '151vh', left: '53vw'}} alt=""/>

        {/* Crumb 7: Question */}
        <img tabIndex="9" onKeyPress={() => {this.showQuestion(1)}} src={MediumCrumb1} onClick={() => {this.showQuestion(1)}} className="medium-interactive-breadcrumb" style={{top: '153vh', left: '41vw'}} alt="Breadcrumb 8"/>
        <img src={SmallCrumb3} className="small-breadcrumb" style={{top: '160vh', left: '27vw'}} alt=""/>
        <img src={LargeCrumb2} className="large-breadcrumb" style={{top: '155vh', left: '12vw'}} alt=""/>

        {/* Crumb 8: Short Audio */}
        {this.props.textMode || 
          <img tabIndex="10" onKeyPress={() => this.onClickShortAudio("audio4")} src={SmallCrumb1} onClick={() => {this.onClickShortAudio("audio4")}} className="small-interactive-breadcrumb" style={{top: '177vh', left: '29vw'}} alt="Breadcrumb 9"/>
        }
        {!this.props.textMode || 
          <img tabIndex="10" onKeyPress={() => {this.showText(8)}} src={SmallCrumb1} onClick={() => {this.showText(8)}} className="small-interactive-breadcrumb" style={{top: '177vh', left: '29vw'}} alt="Breadcrumb 9"/>
        }
        <img src={SmallCrumb3} className="small-breadcrumb" style={{top: '179vh', left: '42vw'}} alt=""/>

        {/* Crumb 9: Long Audio */}
        {this.props.textMode || 
          <img tabIndex="11" onKeyPress={() => this.onClickLongAudio(4, 1)} src={large_crumbs[3]} onClick={() => {this.onClickLongAudio(4, 1)}} className="large-interactive-breadcrumb" style={{top: '173vh', left: '50vw'}} alt="Breadcrumb 10"/>
        }
        {!this.props.textMode || 
          <img tabIndex="11" onKeyPress={() => {this.showText(9)}} src={LargeCrumb1} onClick={() => {this.showText(9)}} className="large-interactive-breadcrumb" style={{top: '173vh', left: '50vw'}} alt="Breadcrumb 10"/>
        }
        <img src={SmallCrumb2} className="small-breadcrumb" style={{top: '192vh', left: '66vw'}} alt=""/>

        {/* Crumb 10: Text */}
        <img tabIndex="12" onKeyPress={() => {this.showText(10)}} className="medium-interactive-breadcrumb" style={{top: '191vh', left: '74vw'}} src={MediumCrumb2} onClick={() => {this.showText(10)}} alt="Breadcrumb 11"/>
        <img src={SmallCrumb1} className="small-breadcrumb" style={{top: '205vh', left: '67vw'}} alt=""/>
        <img src={SmallCrumb3} className="small-breadcrumb" style={{top: '209vh', left: '53vw'}} alt=""/>

        {/* Crumb 11: Short Audio */}
        {this.props.textMode || 
          <img tabIndex="13" onKeyPress={() => {this.onClickShortAudio("audio5")}} className="medium-interactive-breadcrumb" style={{top: '211vh', left: '41vw'}} src={MediumCrumb1} onClick={() => {this.onClickShortAudio("audio5")}} alt="Breadcrumb 12"/>
        }
        {!this.props.textMode || 
          <img tabIndex="13" onKeyPress={() => {this.showText(11)}} className="medium-interactive-breadcrumb" style={{top: '211vh', left: '41vw'}} src={MediumCrumb1} onClick={() => {this.showText(11)}} alt="Breadcrumb 12"/>
        }
        <img src={SmallCrumb2} className="small-breadcrumb" style={{top: '222vh', left: '29vw'}} alt=""/>
        <img src={SmallCrumb3} className="small-breadcrumb" style={{top: '225vh', left: '13vw'}} alt=""/>

        {/* Crumb 12: Long Audio */}
        {this.props.textMode || 
          <img tabIndex="14" onKeyPress={() => this.onClickLongAudio(5, 2)} src={large_crumbs[4]} onClick={() => {this.onClickLongAudio(5, 2)}} className="large-interactive-breadcrumb" style={{top: '223vh', left: '28vw'}} alt="Breadcrumb 13"/>
        }
        {!this.props.textMode || 
          <img tabIndex="14" onKeyPress={() => {this.showText(12)}} src={LargeCrumb2} onClick={() => {this.showText(12)}} className="large-interactive-breadcrumb" style={{top: '223vh', left: '28vw'}} alt="Breadcrumb 13"/>
        }
        <img src={SmallCrumb2} className="small-breadcrumb" style={{top: '244vh', left: '43vw'}} alt=""/>

        {/* Crumb 13: Short Audio */}
        {this.props.textMode || 
          <img tabIndex="15" onKeyPress={() => this.onClickShortAudio("audio6")} src={SmallCrumb1} onClick={() => {this.onClickShortAudio("audio6")}} className="small-interactive-breadcrumb" style={{top: '245vh', left: '55vw'}} alt="Breadcrumb 14"/>
        }
        {!this.props.textMode || 
          <img tabIndex="15" onKeyPress={() => {this.showText(13)}} src={SmallCrumb1} onClick={() => {this.showText(13)}} className="small-interactive-breadcrumb" style={{top: '245vh', left: '55vw'}} alt="Breadcrumb 14"/>
        }
        <img src={SmallCrumb3} className="small-breadcrumb" style={{top: '248vh', left: '66vw'}} alt=""/>

        {/* Crumb 14: Question */}
        <img tabIndex="16" onKeyPress={() => {this.showQuestion(2)}} className="medium-interactive-breadcrumb" style={{top: '250vh', left: '75vw'}} src={MediumCrumb2} onClick={() => {this.showQuestion(2)}} alt="Breadcrumb 15"/>

        {/* Crumb 15: Text */}
        <img tabIndex="17" onKeyPress={() => {this.showText(14)}} src={LargeCrumb2} onClick={() => {this.showText(14)}}  className="large-interactive-breadcrumb" style={{top: '255vh', left: '59vw'}} alt="Breadcrumb 16"/>

        {/* Crumb 16: Short Audio */}
        {this.props.textMode ||
          <img tabIndex="18" onKeyPress={() => {this.onClickShortAudio("audio7")}} src={MediumCrumb1} onClick={() => {this.onClickShortAudio("audio7")}} className="medium-interactive-breadcrumb" style={{top: '266vh', left: '42vw'}} alt="Breadcrumb 17"/>
        }
        {!this.props.textMode ||
          <img tabIndex="18" onKeyPress={() => {this.showText(15)}} src={MediumCrumb1} onClick={() => {this.showText(15)}} className="medium-interactive-breadcrumb" style={{top: '266vh', left: '42vw'}} alt="Breadcrumb 17"/>
        }
        <img src={SmallCrumb2} className="small-breadcrumb" style={{top: '277vh', left: '31vw'}} alt=""/>

        {/* Crumb 17: Short Audio */}
        {this.props.textMode || 
          <img tabIndex="19" onKeyPress={() => this.onClickShortAudio("audio8")} src={SmallCrumb1} onClick={() => {this.onClickShortAudio("audio8")}} className="small-interactive-breadcrumb" style={{top: '281vh', left: '16vw'}} alt="Breadcrumb 18"/>
        }
        {!this.props.textMode || 
          <img tabIndex="19" onKeyPress={() => {this.showText(16)}} src={SmallCrumb1} onClick={() => {this.showText(16)}} className="small-interactive-breadcrumb" style={{top: '281vh', left: '16vw'}} alt="Breadcrumb 18"/>
        }
        <img src={MediumCrumb2} className="medium-breadcrumb" style={{top: '284vh', left: '29vw'}} alt=""/>
        <img src={SmallCrumb3} className="small-breadcrumb" style={{top: '291vh', left: '44vw'}} alt=""/>

        {/* Crumb 18: Long Audio */}
        {this.props.textMode || 
          <img tabIndex="20" onKeyPress={() => this.onClickLongAudio(6, 1)} src={large_crumbs[5]} onClick={() => {this.onClickLongAudio(6, 1)}} className="large-interactive-breadcrumb" style={{top: '286vh', left: '55vw'}} alt="Breadcrumb 19"/>
        }
        {!this.props.textMode || 
          <img tabIndex="20" onKeyPress={() => {this.showText(17)}} src={LargeCrumb1} onClick={() => {this.showText(17)}} className="large-interactive-breadcrumb" style={{top: '286vh', left: '55vw'}} alt="Breadcrumb 19"/>
        }
        <img src={SmallCrumb1} className="small-breadcrumb" style={{top: '305vh', left: '78vw'}} alt=""/>
        <img src={SmallCrumb2} className="small-breadcrumb" style={{top: '318vh', left: '59vw'}} alt=""/>
        <img src={SmallCrumb3} className="small-breadcrumb" style={{top: '319vh', left: '44vw'}} alt=""/>

        {/* Crumb 19: Question */}
        <img tabIndex="21" onKeyPress={() => {this.showQuestion(3)}} src={MediumCrumb1} onClick={() => {this.showQuestion(3)}} className="medium-interactive-breadcrumb" style={{top: '323vh', left: '30vw'}} alt="Breadcrumb 20"/>
        <img src={SmallClump} className="small-clump" style={{top: '332vh', left: '12vw'}} alt=""/>

        {/* Crumb 20: Short Audio */}
        {this.props.textMode || 
          <img tabIndex="22" onKeyPress={() => this.onClickShortAudio("audio9")} onClick={() => this.onClickShortAudio("audio9")} src={SmallCrumb2} className="small-interactive-breadcrumb" style={{top: '357vh', left: '32vw'}} alt="Breadcrumb 21"/>
        }
        {!this.props.textMode || 
          <img tabIndex="22" onKeyPress={() => {this.showText(18)}} onClick={() => {this.showText(18)}} src={SmallCrumb2} className="small-interactive-breadcrumb" style={{top: '357vh', left: '32vw'}} alt="Breadcrumb 21"/>
        }

        {/* Crumb 21: Long Audio */}
        {this.props.textMode || 
          <img tabIndex="23" onKeyPress={() => this.onClickLongAudio(7, 2)} src={large_crumbs[6]} onClick={() => {this.onClickLongAudio(7, 2)}} className="large-interactive-breadcrumb" style={{top: '346vh', left: '44vw'}} alt="Breadcrumb 22"/>
        }
        {!this.props.textMode || 
          <img tabIndex="23" onKeyPress={() => {this.showText(19)}} src={LargeCrumb2} onClick={() => {this.showText(19)}} className="large-interactive-breadcrumb" style={{top: '346vh', left: '44vw'}} alt="Breadcrumb 22"/>
        }
        <img src={SmallCrumb1} className="small-breadcrumb" style={{top: '364vh', left: '62vw'}} alt=""/>

        {/* Crumb 22: Short Audio */}
        {this.props.textMode || 
          <img tabIndex="24" onKeyPress={() => this.onClickShortAudio("audio10")} src={SmallCrumb3} onClick={() => {this.onClickShortAudio("audio10")}} className="small-interactive-breadcrumb" style={{top: '371vh', left: '76vw'}} alt="Breadcrumb 23"/>
        }
        {!this.props.textMode || 
          <img tabIndex="24" onKeyPress={() => {this.showText(20)}} src={SmallCrumb3} onClick={() => {this.showText(20)}} className="small-interactive-breadcrumb" style={{top: '371vh', left: '76vw'}} alt="Breadcrumb 23"/>
        }
        <img src={MediumCrumb2} className="medium-breadcrumb" style={{top: '378vh', left: '59vw'}} alt=""/>
        <img src={SmallCrumb2} className="small-breadcrumb" style={{top: '389vh', left: '45vw'}} alt=""/>

        {/* Crumb 23: Long Audio */}
        {this.props.textMode || 
          <img tabIndex="25" onKeyPress={() => this.onClickLongAudio(8, 2)} src={large_crumbs[7]} onClick={() => {this.onClickLongAudio(8, 2)}} className="large-interactive-breadcrumb" style={{top: '379vh', left: '30vw'}} alt="Breadcrumb 24"/>
        }
        {!this.props.textMode || 
          <img tabIndex="25" onKeyPress={() => {this.showText(21)}} src={LargeCrumb2} onClick={() => {this.showText(21)}} className="large-interactive-breadcrumb" style={{top: '379vh', left: '30vw'}} alt="Breadcrumb 24"/>
        }

        {/* Crumb 24: Question */}
        <img tabIndex="26" onKeyPress={() => this.showQuestion(4)} onClick={() => this.showQuestion(4)} src={LargeClump} className="large-interactive-clump" style={{top: '400vh', left: '6vw'}} alt="Breadcrumb 25"/>

        {/* Crumb 25: Short Audio */}
        {this.props.textMode || 
          <img tabIndex="27" onKeyPress={() => this.onClickShortAudio("audio11")} src={SmallCrumb1} onClick={() => {this.onClickShortAudio("audio11")}} className="small-interactive-breadcrumb" style={{top: '442vh', left: '32vw'}} alt="Breadcrumb 26"/>
        }
        {!this.props.textMode || 
          <img tabIndex="27" onKeyPress={() => {this.showText(22)}} src={SmallCrumb1} onClick={() => {this.showText(22)}} className="small-interactive-breadcrumb" style={{top: '442vh', left: '32vw'}} alt="Breadcrumb 26"/>
        }
        <img src={SmallCrumb2} className="small-breadcrumb" style={{top: '450vh', left: '44vw'}} alt=""/>

        {/* Crumb 26: Text */}
        <img tabIndex="28" onKeyPress={() => {this.showText(23)}} src={MediumCrumb1} onClick={() => {this.showText(23)}} className="medium-interactive-breadcrumb" style={{top: '450vh', left: '59vw'}} alt="Breadcrumb 27"/>
        <img src={SmallCrumb3} className="small-breadcrumb" style={{top: '459vh', left: '75vw'}} alt=""/>
        <img src={SmallCrumb2} className="small-breadcrumb" style={{top: '472vh', left: '61vw'}} alt=""/>

        {/* Crumb 27: Short Audio */}
        {this.props.textMode || 
          <img tabIndex="29" onKeyPress={() => {this.onClickShortAudio("audio12")}} src={MediumCrumb2} onClick={() => {this.onClickShortAudio("audio12")}} className="medium-interactive-breadcrumb" style={{top: '472vh', left: '42vw'}} alt="Breadcrumb 28"/>
        }
        {!this.props.textMode || 
          <img tabIndex="29" onKeyPress={() => {this.showText(24)}} src={MediumCrumb2} onClick={() => {this.showText(24)}} className="medium-interactive-breadcrumb" style={{top: '472vh', left: '42vw'}} alt="Breadcrumb 28"/>
        }

        {/* Crumb 28: Long Audio */}
        {this.props.textMode || 
          <img tabIndex="30" onKeyPress={() => {this.onClickLongAudio(9, 1)}} onClick={() => {this.onClickLongAudio(9, 1)}} src={large_crumbs[8]} className="large-interactive-breadcrumb" style={{top: '473vh', left: '25vw'}} alt="Breadcrumb 29"/>
        }
        {!this.props.textMode ||
          <img tabIndex="30" onKeyPress={() => {this.showText(25)}} onClick={() => {this.showText(25)}} src={LargeCrumb1} className="large-interactive-breadcrumb" style={{top: '473vh', left: '25vw'}} alt="Breadcrumb 29"/>
        }

        {/* Crumb 29: Question */}
        <img tabIndex="31" onKeyPress={() => this.showQuestion(5)} src={SmallCrumb1} onClick={() => {this.showQuestion(5)}} className="small-interactive-breadcrumb" style={{top: '497vh', left: '14vw'}} alt="Breadcrumb 30"/>
        <img src={SmallCrumb2} className="small-breadcrumb" style={{top: '508vh', left: '30vw'}} alt=""/>
        <img src={SmallCrumb3} className="small-breadcrumb" style={{top: '510vh', left: '44vw'}} alt=""/>

        {/* Crumb 30: Long Audio */}
        {this.props.textMode || 
          <img tabIndex="32" onKeyPress={() => this.onClickLongAudio(10, 2)} src={large_crumbs[9]} onClick={() => {this.onClickLongAudio(10, 2)}} className="large-interactive-breadcrumb" style={{top: '505vh', left: '59vw'}} alt="Breadcrumb 31"/>
        }
        {!this.props.textMode || 
          <img tabIndex="32" onKeyPress={() => {this.showText(26)}} src={LargeCrumb2} onClick={() => {this.showText(26)}} className="large-interactive-breadcrumb" style={{top: '505vh', left: '59vw'}} alt="Breadcrumb 31"/>
        }
        <img src={SmallCrumb1} className="small-breadcrumb" style={{top: '527vh', left: '77vw'}} alt=""/>
        <img src={SmallTrio} className="small-trio" style={{top: '541vh', left: '54vw'}} alt=""/>

        {/* Crumb 31: Text */}
        <img tabIndex="33" onKeyPress={() => {this.showText(27)}} src={MediumCrumb1} onClick={() => {this.showText(27)}} className="medium-interactive-breadcrumb" style={{top: '545vh', left: '37vw'}} alt="Breadcrumb 32"/>
        
        {/* Crumb 32: Short Audio */}
        {this.props.textMode || 
          <img tabIndex="34" onKeyPress={() => this.onClickShortAudio("audio13")} onClick={() => this.onClickShortAudio("audio13")} src={LargeClump} className="large-interactive-clump" style={{top: '556vh', left: '12vw'}} alt="Breadcrumb 33"/>
        }
        {!this.props.textMode || 
          <img tabIndex="34" onKeyPress={() => {this.showText(28)}} onClick={() => {this.showText(28)}} src={LargeClump} className="large-interactive-clump" style={{top: '556vh', left: '12vw'}} alt="Breadcrumb 33"/>
        }

        {/* Crumb 33: Long Audio */}
        {this.props.textMode || 
          <img tabIndex="34" onKeyPress={() => this.onClickLongAudio(11, 3)} onClick={() => this.onClickLongAudio(11, 3)} src={large_crumbs[10]} className="assorted-interactive-clump" style={{top: '589vh', left: '35vw'}} alt="Breadcrumb 34"/>
        }
        {!this.props.textMode || 
          <img tabIndex="35" onKeyPress={() => {this.showText(29)}} onClick={() => {this.showText(29)}} src={AssortedClump} className="assorted-interactive-clump" style={{top: '589vh', left: '35vw'}} alt="Breadcrumb 34"/>
        }

        {/* Crumb 34: Text */}
        <img tabIndex="36" onKeyPress={() => {this.showText(30)}} src={MediumCrumb2} onClick={() => {this.showText(30)}} className="medium-interactive-breadcrumb" style={{top: '627vh', left: '78vw'}} alt="Breadcrumb 35"/>

        {/* Crumb 35: Short Audio */}
        {this.props.textMode || 
          <img tabIndex="37" onKeyPress={() => this.onClickShortAudio("audio14")} onClick={() => this.onClickShortAudio("audio14")} src={SmallCrumb2} className="small-interactive-breadcrumb" style={{top: '645vh', left: '60vw'}} alt="Breadcrumb 36"/>
        }
        {!this.props.textMode || 
          <img tabIndex="37" onKeyPress={() => {this.showText(31)}} onClick={() => {this.showText(31)}} src={SmallCrumb2} className="small-interactive-breadcrumb" style={{top: '645vh', left: '60vw'}} alt="Breadcrumb 36"/>
        }
        <img src={SmallCrumb1} className="small-breadcrumb" style={{top: '650vh', left: '45vw'}} alt=""/>
        <img src={SmallCrumb3} className="small-breadcrumb" style={{top: '655vh', left: '30vw'}} alt=""/>
        <img src={SmallCrumb2} className="small-breadcrumb" style={{top: '668vh', left: '15vw'}} alt=""/>

        {/* Crumb 36: Long Audio */}
        {this.props.textMode || 
          <img tabIndex="38" onKeyPress={() => this.onClickLongAudio(12, 2)} src={large_crumbs[11]} onClick={() => {this.onClickLongAudio(12, 2)}} className="large-interactive-breadcrumb" style={{top: '666vh', left: '30vw'}} alt="Breadcrumb 37"/>
        }
        {!this.props.textMode || 
          <img tabIndex="38" onKeyPress={() => {this.showText(32)}} src={LargeCrumb2} onClick={() => {this.showText(32)}} className="large-interactive-breadcrumb" style={{top: '666vh', left: '30vw'}} alt="Breadcrumb 37"/>
        }
        <img src={SmallCrumb3} className="small-breadcrumb" style={{top: '683vh', left: '45vw'}} alt=""/>
        <img src={SmallCrumb1} className="small-breadcrumb" style={{top: '691vh', left: '63vw'}} alt=""/>

        {/* Crumb 37: Question */}
        <img tabIndex="39" onKeyPress={() => {this.showQuestion(6)}} src={MediumCrumb1} onClick={() => {this.showQuestion(6)}} className="medium-interactive-breadcrumb" style={{top: '696vh', left: '77vw'}} alt="Breadcrumb 38"/>
        <img src={SmallCrumb2} className="small-breadcrumb" style={{top: '712vh', left: '62vw'}} alt=""/>
        <img src={SmallTrio} className="small-trio" style={{top: '720vh', left: '38vw'}} alt=""/>

        {/* Crumb 38: Short Audio */}
        {this.props.textMode || 
          <img tabIndex="40" onKeyPress={() => this.onClickShortAudio("audio15")} src={SmallCrumb3} onClick={() => {this.onClickShortAudio("audio15")}} className="small-interactive-breadcrumb" style={{top: '729vh', left: '16vw'}} alt="Breadcrumb 39"/>
        }
        {!this.props.textMode || 
          <img tabIndex="40" onKeyPress={() => {this.showText(33)}} src={SmallCrumb3} onClick={() => {this.showText(33)}} className="small-interactive-breadcrumb" style={{top: '729vh', left: '16vw'}} alt="Breadcrumb 39"/>
        }
        <img src={MediumCrumb2} className="medium-breadcrumb" style={{top: '735vh', left: '38vw'}} alt=""/>
        <img src={MediumCrumb1} className="medium-breadcrumb" style={{top: '744vh', left: '58vw'}} alt=""/>

        {/* Crumb 39: Long Audio */}
        {this.props.textMode || 
          <img tabIndex="41" onKeyPress={() => this.onClickLongAudio(13, 1)} src={large_crumbs[12]} onClick={() => {this.onClickLongAudio(13, 1)}} className="large-interactive-breadcrumb" style={{top: '750vh', left: '74vw'}} alt="Breadcrumb 40"/>
        }
        {!this.props.textMode || 
          <img tabIndex="41" onKeyPress={() => {this.showText(34)}} src={LargeCrumb1} onClick={() => {this.showText(34)}} className="large-interactive-breadcrumb" style={{top: '750vh', left: '74vw'}} alt="Breadcrumb 40"/>
        }
        <img src={SmallCrumb2} className="small-breadcrumb" style={{top: '772vh', left: '60vw'}} alt=""/>
        <img src={SmallCrumb1} className="small-breadcrumb" style={{top: '776vh', left: '46vw'}} alt=""/>

        {/* Crumb 40: Text */}
        <img tabIndex="42" onKeyPress={() => {this.showText(35)}} src={MediumCrumb2} onClick={() => {this.showText(35)}} className="medium-interactive-breadcrumb" style={{top: '780vh', left: '30vw'}} alt="Breadcrumb 41"/>

        {/* Crumb 41: Long Audio */}
        {this.props.textMode || 
          <img tabIndex="43" onKeyPress={() => this.onClickLongAudio(14, 2)} onClick={() => this.onClickLongAudio(14, 2)} src={large_crumbs[13]} className="large-interactive-breadcrumb" style={{top: '785vh', left: '15vw'}} alt="Breadcrumb 42"/>
        }
        {!this.props.textMode || 
          <img tabIndex="43" onKeyPress={() => {this.showText(36)}} onClick={() => {this.showText(36)}} src={LargeCrumb2} className="large-interactive-breadcrumb" style={{top: '785vh', left: '15vw'}} alt="Breadcrumb 42"/>
        }

        {/* Crumb 42: Question */}
        <img tabIndex="44" onKeyPress={() => {this.showQuestion(7)}} src={MediumCrumb1} onClick={() => {this.showQuestion(7)}} className="medium-interactive-breadcrumb" style={{top: '808vh', left: '30vw'}} alt="Breadcrumb 43"/>
        <img src={SmallCrumb2} className="small-breadcrumb" style={{top: '818vh', left: '46vw'}} alt=""/>
        <img src={SmallCrumb3} className="small-breadcrumb" style={{top: '822vh', left: '60vw'}} alt=""/>

        {/* Crumb 43: Short Audio */}
        {this.props.textMode || 
          <img tabIndex="45" onKeyPress={() => this.onClickShortAudio("audio16")} src={SmallCrumb3} onClick={() => {this.onClickShortAudio("audio16")}} className="small-interactive-breadcrumb" style={{top: '830vh', left: '77vw'}} alt="Breadcrumb 44"/>
        }
        {!this.props.textMode || 
          <img tabIndex="45" onKeyPress={() => {this.showText(37)}} src={SmallCrumb3} onClick={() => {this.showText(37)}} className="small-interactive-breadcrumb" style={{top: '830vh', left: '77vw'}} alt="Breadcrumb 44"/>
        }
        <img src={SmallCrumb2} className="small-breadcrumb" style={{top: '844vh', left: '60vw'}} alt=""/>

        {/* Crumb 44: Long Audio */}
        {this.props.textMode || 
          <img tabIndex="46" onKeyPress={() => this.onClickLongAudio(15, 1)} src={large_crumbs[14]} onClick={() => {this.onClickLongAudio(15, 1)}} className="large-interactive-breadcrumb" style={{top: '839vh', left: '40vw'}} alt="Breadcrumb 45"/>
        }
        {!this.props.textMode || 
          <img tabIndex="46" onKeyPress={() => {this.showText(38)}} src={LargeCrumb1} onClick={() => {this.showText(38)}} className="large-interactive-breadcrumb" style={{top: '839vh', left: '40vw'}} alt="Breadcrumb 45"/>
        }
        <img src={SmallCrumb1} className="small-breadcrumb" style={{top: '861vh', left: '30vw'}} alt=""/>

        {/* Crumb 45: Question */}
        <img tabIndex="47" onKeyPress={() => {this.showQuestion(8)}} src={MediumCrumb2} onClick={() => {this.showQuestion(8)}} className="medium-interactive-breadcrumb" style={{top: '870vh', left: '15vw'}} alt="Breadcrumb 46"/>

        {/* Crumb 46: Short Audio */}
        {this.props.textMode ||
          <img tabIndex="48" onKeyPress={() => this.onClickShortAudio("audio17")} onClick={() => this.onClickShortAudio("audio17")} src={AssortedClump} className="assorted-interactive-clump" style={{top: '880vh', left: '30vw'}} alt="Breadcrumb 47"/>
        }
        {!this.props.textMode ||
          <img tabIndex="48" onKeyPress={() => {this.showText(39)}} onClick={() => {this.showText(39)}} src={AssortedClump} className="assorted-interactive-clump" style={{top: '880vh', left: '30vw'}} alt="Breadcrumb 47"/>
        }

        {/* Crumb 47: Long Audio */}
        {this.props.textMode || 
          <img tabIndex="49" onKeyPress={() => this.onClickLongAudio(16, 2)} src={large_crumbs[15]} onClick={() => {this.onClickLongAudio(16, 2)}} className="ex-large-interactive-breadcrumb" style={{top: '902vh', left: '75vw'}} alt="Breadcrumb 48"/>
        }
        {!this.props.textMode || 
          <img tabIndex="49" onKeyPress={() => {this.showText(40)}} src={LargeCrumb2} onClick={() => {this.showText(40)}} className="ex-large-interactive-breadcrumb" style={{top: '902vh', left: '75vw'}} alt="Breadcrumb 48"/>
        }

        {/* Dynamically populated crumbs for responses to questions */}
        {responses.map((item) => (
          <div>
            <img src={SmallCrumb1} className="small-breadcrumb" style={{position: 'absolute', top: this.getTopPosition("crumb") + 'vh', left: this.getLeftPosition()  + 'vw'}} alt=""/>
            <img tabIndex={this.getTabIdx()} onKeyPress={() => {this.setState({ modal_open : true, content_type: 'answer', question_num: item.question, response: item.response})}}  src={SmallCrumb2} onClick={() => {this.setState({ modal_open : true, content_type: 'answer', question_num: item.question, response: item.response})}} className="small-interactive-breadcrumb" style={{position: 'absolute', top: this.getTopPosition("crumb") + 'vh', left: this.getLeftPosition()  + 'vw'}} alt="Audience contributed crumb"/>
          </div>
        ))}

        {/* Credits */}
        <h1 style={{top: this.getTopPosition("header") + 'vh'}} className="credits-header">Credits</h1>
        <p style={{top: this.getTopPosition("header-space") + 'vh'}} className="credits-text"><b>Curator & Creative Director:</b> Kristen Osborn</p>
        <p style={{top: this.getTopPosition("text") + 'vh'}} className="credits-text"><b>Web Developer:</b> Leon Cai</p>
        <p style={{top: this.getTopPosition("text") + 'vh'}} className="credits-text"><b>Composer and Sound Designer:</b> Jeffrey Levin</p>
        <p style={{top: this.getTopPosition("text") + 'vh'}} className="credits-text"><b>Illustrator:</b> Ashleigh Hetrick</p>
        <p style={{top: this.getTopPosition("text") + 'vh'}} className="credits-text"><b>Audio Collage Editor:</b> Kristen Osborn</p>
        <p style={{top: this.getTopPosition("text") + 'vh'}} className="credits-text"><b>UT Faculty Advisor:</b> Megan Alrutz</p>
        <p style={{top: this.getTopPosition("text") + 'vh'}} className="credits-text"><b>Contributors:</b> Rajini Barath, Upasna Barath, Michael Benjamin, Margaret Bridges, Natalia Buchanan, Zoey Crow, Madelyn DePorter, Zachariah Ezer, Andie Flores, Justine Gelfman, Andrea Hart, Barbara Israel, Renae Simone Jarrett, Nick Kaidoo, Nik Kmiecik, Janice Sonia Lee, Jeffrey Levin, Zoë Mallen, Sam Mayer, Mara Mihlfried, Deanna Myers, Kent Osborn, Linda Osborn, Braxton Rae, Ross Robertson, Cameron Scheetz, Daphne Silbiger,  Anna Skidis Vargas, Rachel Wiegardt-Egel <br/> & you</p>
        <p style={{top: this.getTopPosition("header-space") + 'vh'}} className="credits-text">&nbsp;</p> 
        <h1 style={{top: this.getTopPosition("header") + 'vh'}} className="credits-header">About Breadcrumbs</h1>
        <p style={{top: this.getTopPosition("header-space") + 'vh'}} className="credits-text">Breadcrumbs is an audio experience that takes audience members on a journey exploring the relationship between physical and spiritual nourishment. Sifting through gathered memories of childhood foods, the ingredients of joy, grief, and love come together to make a delicious meal of shared connections.</p>
        <p style={{top: this.getTopPosition("footer-space") + 'vh'}} className="credits-text">&nbsp;</p> 

        <Modal
          dialogClassName="crumb-modal"
          show={this.state.modal_open}
          aria-labelledby="contained-modal-title-vcenter"
          style={{backgroundColor: 'rgba(255, 255, 255, 0.85)'}}
          centered
        >
          <div style={{backgroundImage: `url(${CardBackground})`, width: this.state.modalWidth, position: 'relative', left: '50%', transform: 'translateX(-50%)'}}>
            <Modal.Body>
              {this.state.content_type !== 'question' ||
                <div>
                  <Button onKeyPress={() => this.setState({ modal_open : false, response: "", response_submitted: false, words_left: 100 })} onClick={() => this.setState({ modal_open : false, response: "", response_submitted: false, words_left: 100 })} variant="link" style={{color: 'black'}} className="close-icon">
                    <FontAwesomeIcon icon={faTimes} size="lg"/>
                  </Button>
                  <p className="question-header">Add a crumb to the trail...</p>
                  <p className="question-text">{questions[this.state.question_num - 1]}</p>
                  <Form>
                    <Form.Group>
                      <Form.Control 
                        as="textarea" 
                        rows={3}
                        style={{color: 'black', backgroundColor: '#EFD19D', fontFamily: 'SpecialElite'}}
                        value={this.state.response}
                        onChange={e => this.setState({ response: e.target.value, words_left: this.wordsLeft(e.target.value), response_submitted: false })}
                      />
                      <br/>
                    </Form.Group>
                  </Form>
                  {!this.state.response_submitted ||
                    <p className="response-submitted">Response Submitted!</p>
                  }
                  <Button variant="custom" style={{color: 'white', backgroundColor: '#964B00'}} className="submit-button" disabled={this.state.words_left === 100 || this.state.words_left < 0} onClick={() => this.submitResponse(this.state.question_num, this.state.response)}>Share</Button>
                  <p className="words-left">Words Left: {this.state.words_left}</p>
                </div>
              }
              {this.state.content_type !== 'text' ||
                <div>
                  <Button onKeyPress={() => this.setState({ modal_open : false })} onClick={() => this.setState({ modal_open : false })} variant="link" style={{color: 'black'}} className="close-icon">
                    <FontAwesomeIcon icon={faTimes} size="lg"/>
                  </Button>
                  <p className="question-header">{text_stories[this.state.story_num - 1].title}</p>
                  <p className="question-text">{text_stories[this.state.story_num - 1].memory}</p>
                  {/* Left align formatting for certain crumbs */}
                  <p className={this.state.story_num === 3 || this.state.story_num === 9 || this.state.story_num === 40 ? "left-question-text" : "question-text"}>{text_stories[this.state.story_num - 1].story}</p>
                </div>
              }
              {this.state.content_type !== 'answer' ||
                <div>
                  <Button onKeyPress={() => this.setState({ modal_open : false, response: "" })} onClick={() => this.setState({ modal_open : false, response: "" })} variant="link" style={{color: 'black'}} className="close-icon">
                    <FontAwesomeIcon icon={faTimes} size="lg"/>
                  </Button>
                  <p className="question-header"></p>
                  <p className="answer-text"><strong>{questions[this.state.question_num - 1]}</strong></p>
                  <p className="question-text">{this.state.response}</p>
                </div>
              }
            </Modal.Body>
          </div>
        </Modal>
      </div>
    )
  }
}

export default Landing;